export const jaLocalization = {
  ja: {
    grid: {
      EmptyRecord: "表示するレコードはありません",
      True: "本当",
      False: "偽",
      InvalidFilterMessage: "無効なフィルターデータ",
      GroupDropArea: "列ヘッダーをここにドラッグして、列をグループ化します",
      UnGroup: "グループ化を解除するにはここをクリック",
      GroupDisable: "この列ではグループ化が無効になっています",
      FilterbarTitle: '"sフィルターバーセル',
      EmptyDataSourceError:
        "列はAutoGenerate Column GridのdataSourceから生成されるため、DataSourceは初期ロード時に空であってはなりません",
      Add: "追加",
      Edit: "編集",
      Cancel: "キャンセル",
      Update: "更新",
      Delete: "削除",
      Print: "印刷する",
      Pdfexport: "PDFエクスポート",
      Excelexport: "Excelエクスポート",
      Wordexport: "ワードエクスポート",
      Csvexport: "CSVエクスポート",
      Search: "探す",
      Columnchooser: "列",
      Save: "セーブ",
      Item: "項目",
      Items: "アイテム",
      EditOperationAlert: "編集操作のために選択されたレコードがありません",
      DeleteOperationAlert: "削除操作にレコードが選択されていません",
      SaveButton: "セーブ",
      OKButton: "OK",
      CancelButton: "キャンセル",
      EditFormTitle: "の詳細",
      AddFormTitle: "新しいレコードを追加",
      BatchSaveConfirm: "変更を保存してもよろしいですか？",
      BatchSaveLostChanges: "保存していない変更は失われます。続行しますか？",
      ConfirmDelete: "レコードを削除してもよろしいですか？",
      CancelEdit: "変更をキャンセルしてもよろしいですか？",
      ChooseColumns: "列を選択",
      SearchColumns: "検索列",
      Matchs: "一致するものは見つかりませんでした",
      FilterButton: "フィルタ",
      ClearButton: "晴れ",
      StartsWith: "〜で始まる",
      EndsWith: "次で終わる",
      Contains: "含む",
      Equal: "等しい",
      NotEqual: "等しくない",
      LessThan: "未満",
      LessThanOrEqual: "より小さいか等しい",
      GreaterThan: "より大きい",
      GreaterThanOrEqual: "より大きいか等しい",
      ChooseDate: "日付を選択してください",
      EnterValue: "値を入力してください",
      Copy: "コピー",
      Group: "この列でグループ化",
      Ungroup: "この列でグループ解除",
      autoFitAll: "すべての列を自動調整",
      autoFit: "この列を自動調整",
      Export: "書き出す",
      FirstPage: "先頭ページ",
      LastPage: "最後のページ",
      PreviousPage: "前のページ",
      NextPage: "次のページ",
      SortAscending: "ソート昇順",
      SortDescending: "降順で並べ替え",
      EditRecord: "レコードを編集",
      DeleteRecord: "レコードを削除",
      FilterMenu: "フィルタ",
      SelectAll: "すべて選択",
      Blanks: "ブランク",
      FilterTrue: "本当だ",
      FilterFalse: "偽",
      NoResult: "一致するものは見つかりませんでした",
      ClearFilter: "フィルターをクリア",
      NumberFilter: "番号フィルター",
      TextFilter: "テキストフィルター",
      DateFilter: "日付フィルター",
      DateTimeFilter: "日時フィルター",
      MatchCase: "マッチケース",
      Between: "の間に",
      CustomFilter: "カスタムフィルター",
      CustomFilterPlaceHolder: "値を入力してください",
      CustomFilterDatePlaceHolder: "日付を選択してください",
      AND: "そして",
      OR: "または",
      ShowRowsWhere: "行を表示する場所：",
      NotStartsWith: "で始まらない",
      Like: "好き",
      NotEndsWith: "で終わらない",
      NotContains: "含まない",
      IsNull: "ヌル",
      NotNull: "ヌルではない",
      IsEmpty: "空です",
      IsNotEmpty: "空ではない",
      AddCurrentSelection: "現在の選択をフィルターに追加",
      UnGroupButton: "グループ化を解除するには、ここをクリックしてください",
      AutoFitAll: "すべての列を自動調整",
      AutoFit: "この列を自動調整",
      Clear: "クリア",
      FilterMenuDialogARIA: "フィルタメニューダイアログ",
      ExcelFilterDialogARIA: "Excelフィルターダイアログ",
      DialogEditARIA: "編集ダイアログ",
      ColumnChooserDialogARIA: "列の選択",
      ColumnMenuDialogARIA: "列メニューダイアログ",
      CustomFilterDialogARIA: "カスタムフィルターダイアログ",
      SortAtoZ: "AからZに並べ替え",
      SortZtoA: "ZをAに並べ替える",
      SortByOldest: "古いもので並べ替え",
      SortByNewest: "最新で並べ替え",
      SortSmallestToLargest: "最小から最大に並べ替え",
      SortLargestToSmallest: "最大から最小に並べ替え",
      Sort: "選別",
      FilterDescription: "Alt Down を押してフィルター メニューを開きます",
      SortDescription: "Enter キーを押して並べ替えます",
      ColumnMenuDescription: "Alt Down を押して列メニューを開きます",
      GroupDescription: "Ctrl スペースを押してグループ化します",
      ColumnHeader: " 列ヘッダー ",
      TemplateCell: " テンプレートセルです",
      CommandColumnAria: "コマンド列の列ヘッダー ",
      DialogEdit: "ダイアログ編集",
      ClipBoard: "クリップボード",
      GroupButton: "グループボタン",
      UnGroupAria: "グループ解除ボタン",
      GroupSeperator: "グループ化された列のセパレータ",
      UnGroupIcon: "グループ化された列のグループ化を解除します ",
      GroupedSortIcon: "グループ化された列を並べ替える ",
      GroupedDrag: "グループ化された列をドラッグします",
      GroupCaption: " グループキャプションセルです",
      CheckBoxLabel: "チェックボックス",
      Expanded: "エキスパンド",
      Collapsed: "折りたたまれた",
      SelectAllCheckbox: "すべて選択チェックボックス",
      SelectRow: "行を選択",
      AscendingText: "昇順",
      DescendingText: "降順",
      NoneText: "なし",
    },
    pager: {
      currentPageInfo: "{0}ページのうち{1}ページ",
      totalItemsInfo: "（{0}アイテム）",
      firstPageTooltip: "最初のページに移動",
      lastPageTooltip: "最後のページに移動",
      nextPageTooltip: "次のページに進む",
      previousPageTooltip: "前のページに移動",
      nextPagerTooltip: "次のポケットベルアイテムに移動",
      previousPagerTooltip: "前のポケットベルアイテムに移動",
      pagerDropDown: "ページごとのアイテム",
      pagerAllDropDown: "アイテム",
      All: "すべて",
      totalItemInfo: "（{0}アイテム）",
      Container: "ページャ コンテナ",
      Information: "ポケットベル情報",
      ExternalMsg: "ポケットベルの外部メッセージ",
      Page: "ページ ",
      Of: " の ",
      Pages: " ページ",
    },
    kanban: {
      items: "アイテム",
      min: "分",
      max: "マックス",
      cardsSelected: "選択したカード",
      addTitle: "新しいカードを追加",
      editTitle: "カードの詳細を編集",
      deleteTitle: "カードを削除",
      deleteContent: "このカードを削除してもよろしいですか？",
      save: "セーブ",
      delete: "削除する",
      cancel: "キャンセル",
      yes: "はい",
      no: "番号",
      close: "閉じる",
      noCard: "表示するカードがありません",
      unassigned: "未割り当て",
      cards: "カート",
    },
    dropdowns: {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
      overflowCountTemplate: "+${count}以上..",
      selectAllText: "すべて選択",
      unSelectAllText: "すべて選択解除",
      totalCountTemplate: "${count}を選択しました",
    },
    "drop-down-list": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
    },
    "combo-box": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
    },
    "auto-complete": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
    },
    "multi-select": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
      overflowCountTemplate: "+${count}以上..",
      selectAllText: "すべて選択",
      unSelectAllText: "すべて選択解除",
      totalCountTemplate: "${count}を選択しました",
    },
    listbox: {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
      selectAllText: "すべて選択",
      unSelectAllText: "すべて選択解除",
      moveUp: "上に移動",
      moveDown: "下に移動",
      moveTo: "へ引っ越す",
      moveFrom: "から移動",
      moveAllTo: "すべてに移動",
      moveAllFrom: "すべてから移動",
    },
    spreadsheet: {
      InsertingEmptyValue: "参照値が無効です。",
      FindValue: "価値を見つける",
      ReplaceValue: "値を置換",
      FindReplaceTooltip: "検索と置換",
      ByRow: "行ごと",
      ByColumn: "列ごと",
      MatchExactCellElements: "セルの内容全体に一致",
      EnterCellAddress: "セルアドレスを入力してください",
      FindAndReplace: "検索と置換",
      ReplaceAllEnd: " 置き換えられた一致",
      FindNextBtn: "次を見つける",
      FindPreviousBtn: "前を検索",
      ReplaceBtn: "交換",
      ReplaceAllBtn: "すべて置換",
      GotoHeader: "に行く",
      Sheet: "シート",
      SearchWithin: "範囲内で検索",
      SearchBy: "によって検索する",
      Reference: "参照",
      Workbook: "ワークブック",
      NoElements: "お探しのものが見つかりませんでした。",
      FindWhat: "何を見つける",
      ReplaceWith: "と置換する",
      FileName: "ファイル名",
      ExtendValidation:
        "選択範囲には、データ検証のないセルが含まれています。これらのセルに検証を拡張しますか?",
      Yes: "はい",
      No: "いいえ",
      PROPER:
        "テキストを適切な大文字と小文字に変換します。最初の文字を大文字に、その他の文字を小文字にします。",
      Cut: "切る",
      Copy: "コピー",
      Paste: "ペースト",
      PasteSpecial: "形式を選択して貼り付け",
      All: "全て",
      Values: "値",
      Formats: "フォーマット",
      Font: "フォント",
      FontSize: "フォントサイズ",
      Bold: "ボールド",
      Italic: "イタリック",
      Underline: "下線",
      Strikethrough: "取り消し線",
      TextColor: "テキストの色",
      FillColor: "塗りつぶしの色",
      HorizontalAlignment: "水平方向の配置",
      AlignLeft: "左揃え",
      AlignCenter: "中心",
      AlignRight: "右揃え",
      VerticalAlignment: "垂直方向の配置",
      AlignTop: "上揃え",
      AlignMiddle: "中央揃え",
      AlignBottom: "下揃え",
      MergeCells: "セルを結合します",
      MergeAll: "すべてマージ",
      MergeHorizontally: "水平方向に結合",
      MergeVertically: "垂直にマージ",
      Unmerge: "マージ解除",
      UnmergeCells: "セルの結合を解除",
      SelectMergeType: "マージ タイプの選択",
      MergeCellsAlert:
        "セルを結合すると、左上 (一番上) の値のみが保持されます。とにかくマージしますか？",
      PasteMergeAlert: "結合セルに対してはできません。",
      Borders: "国境",
      TopBorders: "上枠",
      LeftBorders: "左ボーダー",
      RightBorders: "右ボーダー",
      BottomBorders: "下罫線",
      AllBorders: "すべての国境",
      HorizontalBorders: "横罫線",
      VerticalBorders: "縦の境界線",
      OutsideBorders: "外側の境界",
      InsideBorders: "内枠",
      NoBorders: "ノーボーダーズ",
      BorderColor: "ボーダの色",
      BorderStyle: "ボーダースタイル",
      InsertFunction: "挿入機能",
      Insert: "入れる",
      Delete: "消去",
      DuplicateSheet: "複製",
      MoveRight: "右に動く",
      MoveLeft: "左に移動",
      Rename: "名前を変更",
      Hide: "隠れる",
      NameBox: "ネームボックス",
      ShowHeaders: "ヘッダーを表示",
      HideHeaders: "ヘッダーを非表示",
      ShowGridLines: "グリッド線を表示",
      HideGridLines: "グリッド線を非表示",
      FreezePanes: "フリーズペイン",
      FreezeRows: "行の凍結",
      FreezeColumns: "列を固定",
      UnfreezePanes: "ペインのフリーズ解除",
      UnfreezeRows: "行の凍結解除",
      UnfreezeColumns: "列の凍結解除",
      AddSheet: "シートを追加",
      ListAllSheets: "すべてのシートを一覧表示",
      CollapseToolbar: "ツールバーを折りたたむ",
      ExpandToolbar: "ツールバーを展開",
      CollapseFormulaBar: "数式バーを折りたたむ",
      ExpandFormulaBar: "数式バーを展開",
      File: "ファイル",
      Home: "家",
      Formulas: "数式",
      View: "意見",
      New: "新しい",
      Open: "開ける",
      SaveAs: "名前を付けて保存",
      ExcelXlsx: "マイクロソフトエクセル",
      ExcelXls: "マイクロソフト エクセル 97-2003",
      CSV: "コンマ区切り値",
      FormulaBar: "数式バー",
      Sort: "選別",
      SortAscending: "上昇",
      SortDescending: "降順",
      CustomSort: "カスタムソート",
      AddColumn: "列を追加",
      ContainsHeader: "データにはヘッダーが含まれています",
      CaseSensitive: "大文字と小文字を区別",
      SortBy: "並び替え",
      ThenBy: "その後、",
      SelectAColumn: "列を選択",
      SortEmptyFieldError:
        "すべてのソート条件には、列を指定する必要があります。選択したソート基準を確認して、再試行してください。",
      SortDuplicateFieldError:
        " 値で複数回ソートされています。重複するソート基準を削除して、再試行してください。",
      SortOutOfRangeError:
        "使用されている範囲内のセルまたは範囲を選択して、やり直してください。",
      MultiRangeSortError:
        "これは、複数の範囲選択では実行できません。 1 つの範囲を選択して、やり直してください。",
      HideRow: "行を非表示",
      HideRows: "行を非表示",
      UnhideRows: "行を再表示",
      HideColumn: "列を非表示",
      HideColumns: "列を非表示",
      UnhideColumns: "列を再表示",
      InsertRow: "行を挿入",
      InsertRows: "行を挿入",
      Above: "その上",
      Below: "下",
      InsertColumn: "列を挿入",
      InsertColumns: "列を挿入する",
      Before: "前",
      After: "後",
      DeleteRow: "行を削除",
      DeleteRows: "行を削除",
      DeleteColumn: "列を削除",
      DeleteColumns: "列を削除",
      Ok: "わかった",
      Close: "近い",
      MoreOptions: "より多くのオプション",
      Cancel: "キャンセル",
      Apply: "申し込み",
      MoreColors: "その他の色",
      StandardColors: "標準色",
      General: "全般的",
      Number: "番号",
      Currency: "通貨",
      Accounting: "会計",
      ShortDate: "ショートデート",
      LongDate: "ロングデート",
      Time: "時間",
      Percentage: "パーセンテージ",
      Fraction: "分数",
      Scientific: "科学的",
      Text: "文章",
      NumberFormat: "数値形式",
      MobileFormulaBarPlaceHolder: "値または数式を入力してください",
      PasteAlert:
        "コピー領域と貼り付け領域が同じサイズではないため、ここに貼り付けることはできません。別の範囲で貼り付けてみてください。",
      DestroyAlert:
        "保存せずに現在のブックを破棄して新しいブックを作成してもよろしいですか?",
      SheetRenameInvalidAlert: "シート名に無効な文字が含まれています。",
      SheetRenameEmptyAlert: "シート名を空にすることはできません。",
      SheetRenameAlreadyExistsAlert:
        "シート名は既に存在します。別の名前を入力してください。",
      DeleteSheetAlert: "このシートを削除してもよろしいですか?",
      DeleteSingleLastSheetAlert:
        "Workbook には、少なくとも 1 つの表示可能なワークシートが含まれている必要があります。",
      PickACategory: "カテゴリを選択",
      Description: "説明",
      UnsupportedFile: "サポートされていないファイル",
      DataLimitExceeded:
        "ファイル データが大きすぎるため、処理に時間がかかります。続行しますか?",
      FileSizeLimitExceeded:
        "ファイル サイズが大きすぎて、処理に時間がかかります。続行しますか?",
      InvalidUrl: "無効なURL",
      SUM: "一連の数値および/またはセルを追加します。",
      SUMIF: "指定された条件に基づいてセルを追加します。",
      SUMIFS: "指定した条件に基づいてセルを追加します。",
      ABS: "数値の符号なしの値を返します。",
      RAND: "0 から 1 の間の乱数を返します。",
      RANDBETWEEN: "指定された値に基づいてランダムな整数を返します。",
      FLOOR: "指定された係数の最も近い倍数に数値を切り捨てます。",
      CEILING: "指定された係数の最も近い倍数に数値を切り上げます。",
      PRODUCT: "一連の数値および/またはセルを乗算します。",
      AVERAGE: "テキストを除く一連の数値および/またはセルの平均を計算します。",
      AVERAGEIF: "指定された基準に基づいてセルの平均を計算します。",
      AVERAGEIFS: "指定された条件に基づいてセルの平均を計算します。",
      AVERAGEA:
        "TRUE を 1、テキストおよび FALSE を 0 と評価するセルの平均を計算します。",
      COUNT: "範囲内の数値を含むセルをカウントします。",
      COUNTIF: "指定した条件で細胞を数えます。",
      COUNTIFS: "指定した条件で細胞を数えます。",
      COUNTA: "範囲内の値を含むセルをカウントします。",
      MIN: "指定された引数の最小数を返します。",
      MAX: "指定された引数の最大数を返します。",
      DATE: "指定された年、月、日に基づいて日付を返します。",
      DAY: "指定された日付から日を返します。",
      DAYS: "2 つの日付の間の日数を返します。",
      IF: "指定された式に基づいて値を返します。",
      IFS: "指定された複数の式に基づいて値を返します。",
      CalculateAND:
        "すべての引数が TRUE の場合は TRUE を返し、それ以外の場合は FALSE を返します。",
      CalculateOR:
        "引数のいずれかが TRUE の場合は TRUE を返し、それ以外の場合は FALSE を返します。",
      IFERROR:
        "エラーが見つからない場合は値を返します。それ以外の場合は、指定された値を返します。",
      CHOOSE: "インデックス番号に基づいて、値のリストから値を返します。",
      INDEX: "行番号と列番号に基づいて、指定された範囲内のセルの値を返します。",
      FIND: "大文字と小文字を区別して、別の文字列内の文字列の位置を返します。",
      CONCATENATE: "2 つ以上の文字列を結合します。",
      CONCAT: "リストまたはテキスト文字列の範囲を連結します。",
      SUBTOTAL: "指定された関数番号を使用して範囲の小計を返します。",
      RADIANS: "度をラジアンに変換します。",
      MATCH: "指定された範囲内の指定された値の相対位置を返します。",
      SLOPE: "データ ポイントの線形回帰から直線の傾きを返します。",
      INTERCEPT: "線形回帰によって Y 切片の点を計算します。",
      UNIQUE: "範囲または配列から一意の値を返します",
      TEXT: "値を指定された数値形式のテキストに変換します。",
      DefineNameExists: "この名前は既に存在します。別の名前を試してください。",
      CircularReference:
        "数式が 1 つ以上の循環参照を参照している場合、計算が正しく行われない可能性があります。",
      SORT: "配列の範囲をソートします",
      T: "値がテキストかどうかをチェックし、テキストを返します。",
      EXACT:
        "2 つのテキスト文字列が完全に同じかどうかをチェックし、TRUE または FALSE を返します。",
      LEN: "指定された文字列の文字数を返します。",
      MOD: "数値を除数で割った余りを返します。",
      ODD: "正の数値と負の数値を最も近い奇数に切り上げます。",
      PI: "円周率の値を返します。",
      COUNTBLANK: "指定されたセル範囲内の空のセルの数を返します。",
      EVEN: "正の数と負の数を最も近い偶数に切り上げます。",
      DECIMAL: "指定された基数の数値のテキスト表現を 10 進数に変換します。",
      ADDRESS:
        "指定された行番号と列番号を指定して、セル参照をテキストとして返します。",
      CHAR: "指定された番号から文字を返します。",
      CODE: "指定された文字列の最初の文字の数値コードを返します。",
      DOLLAR: "数値を通貨形式のテキストに変換します。",
      SMALL: "指定された配列で k 番目に小さい値を返します。",
      LARGE: "指定された配列で k 番目に大きい値を返します。",
      TIME: "時間、分、秒を時刻形式のテキストに変換します。",
      DEGREES: "ラジアンを度に変換します。",
      FACT: "数値の階乗を返します。",
      MEDIAN: "指定された数値セットの中央値を返します。",
      EDATE: "指定された日付から指定された月数だけ前または後の日付を返します。",
      DATEVALUE: "日付文字列を日付値に変換します。",
      NOW: "現在の日付と時刻を返します。",
      HOUR: "指定された時間文字列の時間数を返します。",
      MINUTE: "指定された時間文字列の分数を返します。",
      SECOND: "指定された時間文字列の秒数を返します。",
      MONTH: "指定された日付文字列の月数を返します。",
      OR: "また",
      AND: "と",
      CustomFilterDatePlaceHolder: "日付を選択してください",
      CustomFilterPlaceHolder: "値を入力してください",
      CustomFilter: "カスタム フィルター",
      Between: "間",
      MatchCase: "マッチケース",
      DateTimeFilter: "日時フィルター",
      Undo: "元に戻す",
      Redo: "やり直し",
      ClearAllFilter: "クリア",
      ReapplyFilter: "再申請",
      DateFilter: "日付フィルター",
      TextFilter: "テキスト フィルター",
      NumberFilter: "数値フィルター",
      ClearFilter: "フィルターをクリア",
      NoResult: "一致が見つかりません",
      FilterFalse: "間違い",
      FilterTrue: "真実",
      Blanks: "ブランクス",
      SelectAll: "すべて選択",
      GreaterThanOrEqual: "以上",
      GreaterThan: "より大きい",
      LessThanOrEqual: "以下",
      LessThan: "未満",
      NotEqual: "等しくない",
      Equal: "同等",
      Contains: "含む",
      NotContains: "含まない",
      EndsWith: "次で終わる",
      NotEndsWith: "次で終わらない",
      StartsWith: "次で始まる",
      NotStartsWith: "次で始まらない",
      IsEmpty: "空",
      IsNotEmpty: "空ではない",
      ClearButton: "クリア",
      FilterButton: "フィルター",
      CancelButton: "キャンセル",
      OKButton: "わかった",
      Search: "探す",
      DataValidation: "データ検証",
      CellRange: "セル範囲",
      Allow: "許可する",
      Data: "データ",
      Minimum: "最小",
      Maximum: "最大",
      IgnoreBlank: "空白を無視",
      WholeNumber: "整数",
      Decimal: "小数",
      Date: "日にち",
      TextLength: "テキストの長さ",
      List: "リスト",
      NotBetween: "間にない",
      EqualTo: "に等しい",
      NotEqualTo: "等しくない",
      GreaterThanOrEqualTo: "以上",
      LessThanOrEqualTo: "以下",
      InCellDropDown: "セル内ドロップダウン",
      Sources: "ソース",
      Value: "価値",
      Retry: "リトライ",
      DialogError:
        "リスト ソースは、単一の行または列への参照である必要があります。",
      MinMaxError: "最大値は最小値以上である必要があります。",
      InvalidNumberError: "有効な番号を入力してください。",
      Spreadsheet: "スプレッドシート",
      MoreValidation: "この選択には、複数の検証が含まれています。",
      FileNameError:
        'ファイル名に \\ / : * ? などの文字を含めることはできません。 " < > [ ] |',
      ValidationError:
        "この値は、セルに定義されたデータ検証の制限と一致しません。",
      ListLengthError: "リストの値は 256 文字までしか使用できません",
      ProtectSheet: "プロテクトシート",
      UnprotectSheet: "シートの保護を解除",
      SelectCells: "ロックされたセルを選択",
      SelectUnlockedCells: "ロックされていないセルを選択",
      Save: "セーブ",
      EmptyFileName: "ファイル名を空にすることはできません。",
      LargeName: "名前が長すぎます。",
      FormatCells: "セルの書式設定",
      FormatRows: "行のフォーマット",
      FormatColumns: "列の書式設定",
      InsertLinks: "リンクを挿入する",
      ProtectContent: "ロックされたセルの内容を保護する",
      ProtectAllowUser:
        " このワークシートのすべてのユーザーに次のことを許可します。",
      EditAlert:
        "変更しようとしているセルは保護されています。変更するには、シートの保護を解除してください。",
      ReadonlyAlert:
        "読み取り専用モードのセルを変更しようとしています。変更を行うには、読み取り専用ステータスを無効にしてください。",
      ClearValidation: "クリア検証",
      ISNUMBER: "値が数値として解析される場合は true を返します。",
      ROUND: "数値を指定された桁数に丸めます。",
      GEOMEAN: "正のデータの配列または範囲の幾何平均を返します。",
      POWER: "数値の累乗の結果を返します",
      LOG: "指定した底に対する数値の対数を返します。",
      TRUNC: "指定された小数点以下の桁数に数値を切り捨てた値を返します。",
      EXP: "指定された数で累乗された e を返します。",
      LOOKUP:
        "行または列の範囲内の値を検索し、行または列の範囲内の同じ位置にある値を返します。",
      HLOOKUP:
        "値テーブルの最上行の値を検索し、指定されたテーブル行の同じ列の値を返します。",
      VLOOKUP:
        "検索範囲の最初の列で指定された値を検索し、行の 2 列目の対応する値を返します。",
      NOT: "指定されたブール式の逆数を返します。",
      EOMONTH:
        "最初に指定された開始日から指定された月数前または後の月の最後の日を返します。",
      SQRT: "正の数の平方根を返します。",
      ROUNDDOWN: "数値をゼロに丸めます。",
      RSQ: "known_y および known_x データ ポイントに基づいて、二乗ピアソン積モーメント相関係数を返します。",
      HighlightCellsRules: "セルの強調表示ルール",
      CFEqualTo: "に等しい",
      TextThatContains: "含まれるテキスト",
      ADateOccuring: "発生日",
      DuplicateValues: "重複値",
      TopBottomRules: "上/下のルール",
      Top10Items: "トップ10アイテム",
      Top10: "トップ10",
      Bottom10Items: "下位 10 項目",
      Bottom10: "下位10位",
      AboveAverage: "平均以上",
      BelowAverage: "平均以下の",
      FormatCellsGreaterThan: "GREATER THAN のセルを書式設定する:",
      FormatCellsLessThan: "LESS THAN のセルを書式設定する:",
      FormatCellsBetween: "BETWEEN のセルを書式設定:",
      FormatCellsEqualTo: "等しいセルをフォーマットする:",
      FormatCellsThatContainTheText: "テキストを含むセルをフォーマットします。",
      FormatCellsThatContainADateOccurring:
        "発生した日付を含むセルをフォーマットします。",
      FormatCellsDuplicate: "以下を含むセルを書式設定します。",
      FormatCellsTop: "TOP にランク付けされたセルをフォーマットします。",
      FormatCellsBottom: "BOTTOM にランク付けされたセルをフォーマットします。",
      FormatCellsAbove: "ABOVE AVERAGE のセルを書式設定する:",
      FormatCellsBelow: "BELOW AVERAGE のセルをフォーマットする:",
      With: "と",
      DataBars: "データ バー",
      ColorScales: "カラースケール",
      IconSets: "アイコンセット",
      ClearRules: "クリアルール",
      SelectedCells: "選択したセルからルールをクリア",
      EntireSheet: "シート全体からルールをクリア",
      LightRedFillWithDarkRedText: "薄い赤で塗りつぶし、濃い赤のテキスト",
      YellowFillWithDarkYellowText: "濃い黄色のテキストで黄色の塗りつぶし",
      GreenFillWithDarkGreenText: "緑の塗りつぶし、濃い緑のテキスト",
      RedFill: "レッドフィル",
      RedText: "赤いテキスト",
      Duplicate: "複製",
      Unique: "個性的",
      And: "と",
      WebPage: "ウェブページ",
      ThisDocument: "このドキュメント",
      DisplayText: "表示テキスト",
      Url: "URL",
      CellReference: "セル参照",
      DefinedNames: "定義された名前",
      EnterTheTextToDisplay: "表示するテキストを入力してください",
      EnterTheUrl: "URLを入力してください",
      INT: "数値を最も近い整数に戻します。",
      SUMPRODUCT: "指定された範囲の配列の積の合計を返します。",
      TODAY: "現在の日付を日付値として返します。",
      ROUNDUP: "ゼロ以外の数値を丸めます。",
      Link: "リンク",
      Hyperlink: "ハイパーリンク",
      EditHyperlink: "ハイパーリンクを編集",
      OpenHyperlink: "ハイパーリンクを開く",
      RemoveHyperlink: "ハイパーリンクを削除",
      InvalidHyperlinkAlert:
        "このサイトのアドレスは無効です。アドレスを確認して、もう一度お試しください。",
      InsertLink: "リンクを挿入",
      EditLink: "リンクを編集",
      WrapText: "テキストを折り返す",
      Update: "アップデート",
      SortAndFilter: "並べ替えとフィルター",
      Filter: "フィルター",
      FilterCellValue: "選択したセルの値でフィルタ",
      FilterOutOfRangeError:
        "使用されている範囲内のセルまたは範囲を選択して、やり直してください。",
      ClearFilterFrom: "フィルターをクリアする",
      LN: "数値の自然対数を返します。",
      DefineNameInValid: "入力した名前は無効です。",
      EmptyError: "値を入力してください",
      ClearHighlight: "ハイライトをクリア",
      HighlightInvalidData: "無効なデータをハイライト",
      Clear: "クリア",
      ClearContents: "内容をクリア",
      ClearAll: "すべてクリア",
      ClearFormats: "クリアフォーマット",
      ClearHyperlinks: "ハイパーリンクをクリア",
      Image: "画像",
      ConditionalFormatting: "条件付き書式",
      BlueDataBar: "青いデータ バー",
      GreenDataBar: "緑のデータ バー",
      RedDataBar: "赤いデータ バー",
      OrangeDataBar: "オレンジ色のデータ バー",
      LightBlueDataBar: "水色のデータ バー",
      PurpleDataBar: "紫色のデータ バー",
      GYRColorScale: "緑 - 黄 - 赤のカラー スケール",
      RYGColorScale: "赤 - 黄 - 緑のカラー スケール",
      GWRColorScale: "緑 - 白 - 赤のカラー スケール",
      RWGColorScale: "赤 - 白 - 緑のカラー スケール",
      BWRColorScale: "青 - 白 - 赤のカラー スケール",
      RWBColorScale: "赤 - 白 - 青のカラー スケール",
      WRColorScale: "白 - 赤のカラー スケール",
      RWColorScale: "赤 - 白のカラー スケール",
      GWColorScale: "緑 - 白のカラー スケール",
      WGColorScale: "白 - 緑のカラー スケール",
      GYColorScale: "緑 - 黄のカラー スケール",
      YGColorScale: "黄 - 緑のカラー スケール",
      ThreeArrowsColor: "3 矢印 (色付き)",
      ThreeArrowsGray: "3 矢印 (グレー)",
      ThreeTriangles: "3つの三角形",
      FourArrowsColor: "4 矢印 (グレー)",
      FourArrowsGray: "4 矢印 (色付き)",
      FiveArrowsColor: "5 矢印 (グレー)",
      FiveArrowsGray: "5 矢印 (色付き)",
      ThreeTrafficLights1: "3 つの信号機 (縁なし)",
      ThreeTrafficLights2: "3 信号機 (リム付き)",
      ThreeSigns: "3 サイン",
      FourTrafficLights: "4 信号機",
      RedToBlack: "赤から黒へ",
      ThreeSymbols1: "3 つの記号 (丸で囲んだ部分)",
      ThreeSymbols2: "3 つの記号 (丸なし)",
      ThreeFlags: "3 フラグ",
      ThreeStars: "3つ星",
      FourRatings: "4 評価",
      FiveQuarters: "5クォーター",
      FiveRatings: "5 評価",
      FiveBoxes: "5箱",
      Chart: "チャート",
      Column: "桁",
      Bar: "バー",
      Area: "範囲",
      Pie: "パイ",
      Doughnut: "ドーナツ",
      PieAndDoughnut: "パイ・ドーナツ",
      Line: "ライン",
      Radar: "レーダー",
      Scatter: "散布",
      ChartDesign: "グラフのデザイン",
      ClusteredColumn: "クラスター化された列",
      StackedColumn: "積み上げ縦棒",
      StackedColumn100: "100% 積み上げ縦棒",
      ClusteredBar: "クラスタ化されたバー",
      StackedBar: "積み上げ棒",
      StackedBar100: "100%積み上げ棒グラフ",
      StackedArea: "積み上げ面積",
      StackedArea100: "100% 積み上げ面積",
      StackedLine: "積上げ線",
      StackedLine100: "100% 積み上げ線",
      LineMarker: "マーカー付きの線",
      StackedLineMarker: "マーカー付きの積み上げ線",
      StackedLine100Marker: "マーカー付きの 100% 積み上げ線",
      AddChartElement: "グラフ要素を追加",
      Axes: "軸",
      AxisTitle: "軸のタイトル",
      ChartTitle: "グラフのタイトル",
      DataLabels: "データ ラベル",
      Gridlines: "グリッドライン",
      Legends: "伝説",
      PrimaryHorizontal: "プライマリ水平",
      PrimaryVertical: "プライマリ バーティカル",
      None: "なし",
      AboveChart: "上図",
      Center: "中心",
      InsideEnd: "インサイドエンド",
      InsideBase: "インサイドベース",
      OutsideEnd: "アウトサイドエンド",
      PrimaryMajorHorizontal: "主主水平",
      PrimaryMajorVertical: "プライマリ メジャー 垂直",
      PrimaryMinorHorizontal: "プライマリ マイナー ホリゾンタル",
      PrimaryMinorVertical: "プライマリーマイナーバーティカル",
      Right: "右",
      Left: "左",
      Bottom: "下",
      Top: "上",
      SwitchRowColumn: "行/列の切り替え",
      ChartTheme: "グラフのテーマ",
      ChartType: "グラフの種類",
      Material: "素材",
      Fabric: "ファブリック",
      Bootstrap: "ブートストラップ",
      HighContrastLight: "ハイコントラストライト",
      MaterialDark: "マテリアルダーク",
      FabricDark: "ファブリックダーク",
      HighContrast: "ハイコントラスト",
      BootstrapDark: "ブートストラップ ダーク",
      Bootstrap4: "ブートストラップ4",
      Bootstrap5Dark: "Bootstrap5 ダーク",
      Bootstrap5: "ブートストラップ5",
      Tailwind: "追い風",
      TailwindDark: "追い風ダーク",
      VerticalAxisTitle: "縦軸のタイトル",
      HorizontalAxisTitle: "横軸のタイトル",
      EnterTitle: "タイトルを入力",
      UnprotectWorksheet: "シートの保護を解除",
      ReEnterPassword: "続行するにはパスワードを再入力してください",
      SheetPassword: "シートの保護を解除するパスワード:",
      ProtectWorkbook: "ブックの保護",
      Password: "パスワード (オプション):",
      EnterThePassword: "パスワードを入力してください",
      ConfirmPassword: "パスワードを認証する",
      EnterTheConfirmPassword: "パスワードを再入力してください",
      PasswordAlert: "確認パスワードが同一ではありません",
      UnprotectWorkbook: "ブックの保護を解除する",
      UnprotectPasswordAlert: "入力したパスワードが正しくありません。",
      IncorrectPassword:
        "指定されたパスワードでファイルまたはワークシートを開くことができません",
      PasswordAlertMsg: "パスワードを入力してください",
      ConfirmPasswordAlertMsg: "確認用パスワードを入力してください",
      IsProtected: "保護されています",
      PDF: "PDF文書",
      AutoFillMergeAlertMsg:
        "これを行うには、結合されたすべてのセルが同じサイズである必要があります。",
      Fluent: "流暢",
      FluentDark: "フルーエントダーク",
      Fluent2: "流暢 2",
      Fluent2Dark: "フルーエント 2 ダーク",
      Fluent2HighContrast: "Fluent 2 ハイコントラスト",
      Custom: "カスタム",
      WEEKDAY: "日付に対応する曜日を返します。",
      FillSeries: "塗りつぶしシリーズ",
      CopyCells: "セルをコピー",
      FillFormattingOnly: "塗りつぶし書式のみ",
      FillWithoutFormatting: "フォーマットせずに埋める",
      CustomFormat: "カスタム数値フォーマット",
      CustomFormatPlaceholder: "カスタム形式を入力または選択してください",
      CustomFormatTypeList: "タイプ",
      CellReferenceTypoError:
        "セル参照にタイプミスが見つかりました。この参照を次のように修正しますか?",
      AddCurrentSelection: "現在の選択をフィルターに追加",
      ExternalWorkbook:
        "インポートされた Excel ファイルには、外部ワークブック参照が含まれています。そのファイルをインポートしますか?",
      Directional: "指向性",
      Shapes: "形",
      Indicators: "指標",
      Ratings: "評価",
      InvalidFormulaError: "無効な数式を入力したことがわかりました。",
      InvalidArguments: "無効な引数を含む数式を入力したことがわかりました。",
      EmptyExpression: "空の式を含む数式を入力したことがわかりました。",
      MismatchedParenthesis:
        "1 つ以上の開き括弧または閉じ括弧が欠落している数式を入力したことがわかりました。",
      ImproperFormula: "不適切な数式を入力したことがわかりました。",
      WrongNumberOfArguments:
        "間違った数の引数を含む数式を入力したことがわかりました。",
      Requires3Arguments:
        "3 つの引数を必要とする数式を入力したことがわかりました。",
      MismatchedStringQuotes:
        "引用符が一致しない数式を入力したことがわかりました。",
      FormulaCircularRef: "循環参照を含む数式を入力したことがわかりました。",
    },
    filemanager: {
      NewFolder: "新しいフォルダー",
      Upload: "アップロードする",
      Delete: "削除",
      Rename: "リネーム",
      Download: "ダウンロード",
      Cut: "切る",
      Copy: "コピー",
      Paste: "ペースト",
      SortBy: "並び替え",
      Refresh: "リフレッシュ",
      "Item-Selection": "選択されたアイテム",
      "Items-Selection": "選択されたアイテム",
      View: "見る",
      Details: "詳細",
      SelectAll: "すべて選択",
      Open: "開いた",
      "Tooltip-NewFolder": "新しいフォルダー",
      "Tooltip-Upload": "アップロードする",
      "Tooltip-Delete": "削除",
      "Tooltip-Rename": "リネーム",
      "Tooltip-Download": "ダウンロード",
      "Tooltip-Cut": "切る",
      "Tooltip-Copy": "コピー",
      "Tooltip-Paste": "ペースト",
      "Tooltip-SortBy": "並び替え",
      "Tooltip-Refresh": "リフレッシュ",
      "Tooltip-Selection": "明確な選択",
      "Tooltip-View": "見る",
      "Tooltip-Details": "詳細",
      "Tooltip-SelectAll": "すべて選択",
      Name: "名前",
      Size: "サイズ",
      DateModified: "修正済み",
      DateCreated: "作成日",
      Path: "道",
      Modified: "修正済み",
      Created: "作成した",
      Location: "ロケーション",
      Type: "タイプ",
      Permission: "許可",
      Ascending: "上昇",
      Descending: "降順",
      None: "なし",
      "View-LargeIcons": "大きなアイコン",
      "View-Details": "詳細",
      Search: "探す",
      "Button-Ok": "OK",
      "Button-Cancel": "キャンセル",
      "Button-Yes": "はい",
      "Button-No": "番号",
      "Button-Create": "作成する",
      "Button-Save": "セーブ",
      "Header-NewFolder": "フォルダ",
      "Content-NewFolder": "フォルダー名を入力してください",
      "Header-Rename": "リネーム",
      "Content-Rename": "新しい名前を入力してください",
      "Header-Rename-Confirmation": "確認の名前を変更",
      "Content-Rename-Confirmation":
        "ファイル名拡張子を変更すると、ファイルが不安定になる可能性があります。変更してもよろしいですか？",
      "Header-Delete": "ファイルを削除する",
      "Content-Delete": "このファイルを削除してもよろしいですか？",
      "Header-Folder-Delete": "フォルダを削除",
      "Content-Folder-Delete": "このフォルダを削除してもよろしいですか？",
      "Header-Multiple-Delete": "複数のファイルを削除する",
      "Content-Multiple-Delete":
        "これらの{0}ファイルを削除してもよろしいですか？",
      "Header-Duplicate": "ファイル/フォルダーが存在します",
      "Content-Duplicate":
        "{0}はすでに存在します。名前を変更して貼り付けますか？",
      "Header-Upload": "ファイルをアップロードする",
      Error: "エラー",
      "Validation-Empty":
        "ファイルまたはフォルダー名を空にすることはできません。",
      "Validation-Invalid":
        'ファイルまたはフォルダー名{0}に無効な文字が含まれています。別の名前を使用してください。有効なファイル名またはフォルダー名の末尾にドットまたはスペースを含めることはできません。また、次の文字を含めることはできません。\\ /：*？ "<> |',
      "Validation-NewFolder-Exists":
        "{0}という名前のファイルまたはフォルダーは既に存在します。",
      "Validation-Rename-Exists":
        "{0}を{1}に名前変更できません：宛先は既に存在します。",
      "Folder-Empty": "このフォルダーは空です",
      "File-Upload": "ここにファイルをドラッグしてアップロードします",
      "Search-Empty": "結果が見つかりません",
      "Search-Key": "別のキーワードで試してください",
      "Filter-Empty": "結果が見つかりません",
      "Filter-Key": "別のフィルターで試してください",
      "Sub-Folder-Error":
        "宛先フォルダーは、ソースフォルダーのサブフォルダーです。",
      "Same-Folder-Error": "宛先フォルダーはソースフォルダーと同じです。",
      "Access-Denied": "アクセスが拒否されました",
      "Access-Details": "このフォルダにアクセスする権限がありません。",
      "Header-Retry": "ファイルが既に存在します",
      "Content-Retry":
        "この名前のファイルはこのフォルダーに既に存在します。何をしたいですか？",
      "Button-Keep-Both": "両方とも",
      "Button-Replace": "交換",
      "Button-Skip": "スキップ",
      "ApplyAll-Label": "現在のすべてのアイテムのためにこれを行います",
      KB: "KB",
      "Access-Message":
        "{0}にはアクセスできません。 {1}アクションを実行するには権限が必要です。",
      "Network-Error":
        "XMLHTTPRequestでの送信に失敗しました：ロードに失敗しました",
      "Server-Error": "サーバーエラー：からの無効な応答",
    },
    calendar: {
      today: "今日",
    },
    datepicker: {
      today: "今日",
      placeholder: "日付を選択してください",
    },
    daterangepicker: {
      placeholder: "期間を選択してください",
      startLabel: "開始日",
      endLabel: "終了日",
      applyText: "適用する",
      cancelText: "キャンセル",
      selectedDays: "選択された日",
      days: "日々",
      customRange: "カスタム範囲",
    },
    timepicker: {
      placeholder: "時間を選んでください",
    },
    datetimepicker: {
      today: "今日",
      placeholder: "日付と時刻を選択してください",
    },
    dialog: {
      close: "閉じる",
    },
    toast: {
      close: "閉じる",
    },
    tab: {
      closeButtonTitle: "閉じる",
    },
    schedule: {
      day: "日",
      week: "週間",
      workWeek: "仕事の週",
      month: "月",
      year: "年",
      agenda: "議題",
      weekAgenda: "週間アジェンダ",
      workWeekAgenda: "労働週間の議題",
      monthAgenda: "月の議題",
      today: "今日",
      noEvents: "イベントなし",
      emptyContainer: "この日に予定されているイベントはありません。",
      allDay: "一日中",
      start: "開始",
      end: "終わり",
      more: "もっと",
      close: "閉じる",
      cancel: "キャンセル",
      noTitle: "（無題）",
      delete: "削除",
      deleteEvent: "このイベント",
      deleteMultipleEvent: "複数のイベントを削除する",
      selectedItems: "選択されたアイテム",
      deleteSeries: "シリーズ全体",
      edit: "編集",
      editSeries: "シリーズ全体",
      editEvent: "このイベント",
      createEvent: "作成する",
      subject: "件名",
      addTitle: "表題を加える",
      moreDetails: "詳細",
      moreEvents: "もっとイベント",
      save: "セーブ",
      editContent: "シリーズの予定をどのように変更しますか?",
      deleteContent: "このイベントを削除してもよろしいですか？",
      deleteMultipleContent: "選択したイベントを削除してもよろしいですか？",
      newEvent: "新しいイベント",
      title: "題名",
      location: "ロケーション",
      description: "説明",
      timezone: "タイムゾーン",
      startTimezone: "タイムゾーンを開始",
      endTimezone: "終了タイムゾーン",
      repeat: "繰り返す",
      saveButton: "セーブ",
      cancelButton: "キャンセル",
      deleteButton: "削除",
      recurrence: "再発",
      wrongPattern: "繰り返しパターンは無効です。",
      seriesChangeAlert:
        "このシリーズの特定のインスタンスに加えられた変更をキャンセルし、再びシリーズ全体に一致させますか？",
      createError:
        "イベントの期間は、発生する頻度よりも短くする必要があります。期間を短くするか、繰り返しイベントエディターで繰り返しパターンを変更します。",
      sameDayAlert: "同じイベントが同じ日に2回発生することはできません。",
      occurenceAlert:
        "同じ予定のその後の発生をスキップした場合、定期的な予定の発生を再スケジュールすることはできません。",
      editRecurrence: "繰り返しを編集",
      repeats: "繰り返し",
      alert: "アラート",
      startEndError: "選択した終了日は、開始日より前に発生します。",
      invalidDateError: "入力された日付値は無効です。",
      blockAlert:
        "ブロックされた時間範囲内でイベントをスケジュールすることはできません。",
      ok: "OK",
      of: "の",
      yes: "はい",
      no: "番号",
      occurrence: "発生",
      series: "シリーズ",
      previous: "前",
      next: "次",
      timelineDay: "タイムラインの日",
      timelineWeek: "タイムラインウィーク",
      timelineWorkWeek: "タイムラインワークウィーク",
      timelineMonth: "タイムライン月",
      timelineYear: "タイムライン年",
      editFollowingEvent: "次のイベント",
      deleteTitle: "イベントを削除",
      editTitle: "イベントを編集",
      beginFrom: "から始まる",
      endAt: "で終了",
      expandAllDaySection: "終日展開セクション",
      collapseAllDaySection: "崩壊-終日-セクション",
      searchTimezone: "タイムゾーンを検索",
      noRecords: "レコードが見つかりません",
    },
    recurrenceeditor: {
      none: "なし",
      daily: "毎日",
      weekly: "毎週",
      monthly: "毎月",
      month: "月",
      yearly: "毎年",
      never: "決して",
      until: "まで",
      count: "カウント",
      first: "最初",
      second: "第二",
      third: "三番",
      fourth: "第4",
      last: "最終",
      repeat: "繰り返す",
      repeatEvery: "繰り返す",
      on: "繰り返し",
      end: "終わり",
      onDay: "日",
      days: "日々）",
      weeks: "週",
      months: "月",
      years: "年",
      every: "毎回",
      summaryTimes: "時間",
      summaryOn: "オン",
      summaryUntil: "まで",
      summaryRepeat: "繰り返し",
      summaryDay: "日々）",
      summaryWeek: "週",
      summaryMonth: "月",
      summaryYear: "年",
      monthWeek: "月週",
      monthPosition: "月の位置",
      monthExpander: "月エキスパンダー",
      yearExpander: "年エキスパンダー",
      repeatInterval: "繰り返し間隔",
    },
    gantt: {
      emptyRecord: "表示するレコードはありません",
      id: "ID",
      name: "名前",
      startDate: "開始日",
      endDate: "終了日",
      duration: "期間",
      progress: "進捗",
      dependency: "依存",
      notes: "ノート",
      baselineStartDate: "ベースライン開始日",
      baselineEndDate: "ベースライン終了日",
      taskMode: "タスクモード",
      changeScheduleMode: "スケジュールモードの変更",
      subTasksStartDate: "サブタスクの開始日",
      subTasksEndDate: "サブタスクの終了日",
      scheduleStartDate: "スケジュール開始日",
      scheduleEndDate: "スケジュールの終了日",
      auto: "自動",
      manual: "マニュアル",
      type: "タイプ",
      offset: "オフセット",
      resourceName: "資源",
      resourceID: "リソースID",
      day: "日",
      hour: "時",
      minute: "分",
      days: "日々",
      hours: "時間",
      minutes: "数分",
      generalTab: "全般",
      customTab: "カスタム列",
      writeNotes: "メモを書く",
      addDialogTitle: "新しい仕事",
      editDialogTitle: "タスク情報",
      saveButton: "セーブ",
      add: "追加",
      edit: "編集",
      update: "更新",
      delete: "削除",
      cancel: "キャンセル",
      search: "探す",
      task: " 仕事",
      tasks: " タスク",
      zoomIn: "ズームイン",
      zoomOut: "ズームアウトする",
      zoomToFit: "ズームして合わせる",
      excelExport: "Excelエクスポート",
      csvExport: "CSVエクスポート",
      expandAll: "すべて展開",
      collapseAll: "すべて折りたたむ",
      nextTimeSpan: "次のタイムスパン",
      prevTimeSpan: "前のタイムスパン",
      okText: "OK",
      confirmDelete: "レコードを削除してもよろしいですか？",
      from: "から",
      to: "に",
      taskLink: "タスクリンク",
      lag: "遅れ",
      start: "開始",
      finish: "終わり",
      enterValue: "値を入力してください",
      taskBeforePredecessor_FS:
        "「{1}」が終了し、2つのタスクがリンクされる前に「{0}」を移動して開始しました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskAfterPredecessor_FS:
        "「{0}」を「{1}」から遠ざけ、2つのタスクがリンクされました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskBeforePredecessor_SS:
        "'{1}'が開始する前に開始するために '{0}'を移動し、2つのタスクがリンクされました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskAfterPredecessor_SS:
        "'{1}'の開始後に開始するために '{0}'を移動し、2つのタスクがリンクされました。その結果、リンクは尊重されません。以下のアクションを1つ選択して実行します",
      taskBeforePredecessor_FF:
        "「{1}」が完了する前に「{0}」を移動して終了し、2つのタスクがリンクされました。その結果、リンクは尊重されません。以下のアクションを1つ選択して実行します",
      taskAfterPredecessor_FF:
        "「{1}」が終了し、2つのタスクがリンクされた後、「{0}」を移動して終了しました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskBeforePredecessor_SF:
        "「{0}」を「{1}」から離れて開始に移動し、2つのタスクがリンクされました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskAfterPredecessor_SF:
        "「{1}」が開始し、2つのタスクがリンクされた後、「{0}」を移動して終了しました。その結果、リンクは尊重されません。実行するアクションを以下から1つ選択してください",
      taskInformation: "タスク情報",
      deleteTask: "タスクを削除",
      deleteDependency: "依存関係を削除",
      convert: "変換する",
      save: "セーブ",
      above: "上",
      below: "未満",
      child: "子",
      milestone: "マイルストーン",
      toTask: "タスクへ",
      toMilestone: "マイルストーンへ",
      eventMarkers: "イベントマーカー",
      leftTaskLabel: "左タスクラベル",
      rightTaskLabel: "正しいタスクラベル",
      timelineCell: "タイムラインセル",
      confirmPredecessorDelete: "依存関係リンクを削除してもよろしいですか？",
      unit: "単位",
      work: "作業",
      taskType: "タスクの種類",
      unassignedTask: "割り当てられていないタスク",
      group: "グループ",
      indent: "インデント",
      outdent: "アウトデント",
      segments: "セグメント",
      splitTask: "分割タスク",
      mergeTask: "マージタスク",
      left: "左",
      right: "正しい",
      FF: "FF",
      FS: "FS",
      SF: "SF",
      SS: "SS",
    },
    richtexteditor: {
      alignments: "アライメント",
      justifyLeft: "左揃え",
      justifyCenter: "中央揃え",
      justifyRight: "右揃え",
      justifyFull: "両端揃え",
      fontName: "フォント名",
      fontSize: "フォントサイズ",
      fontColor: "フォントの色",
      backgroundColor: "背景色",
      bold: "大胆な",
      italic: "イタリック",
      underline: "下線",
      strikethrough: "取り消し線",
      clearFormat: "クリアフォーマット",
      clearAll: "すべてクリア",
      cut: "切る",
      copy: "コピー",
      paste: "ペースト",
      unorderedList: "箇条書き",
      orderedList: "番号付きリスト",
      indent: "インデントを増やします",
      outdent: "インデントを減らす",
      undo: "元に戻す",
      redo: "やり直し",
      superscript: "上付き",
      subscript: "添字",
      createLink: "ハイパーリンクを挿入",
      openLink: "リンクを開く",
      editLink: "リンクを編集",
      removeLink: "リンクを削除",
      image: "画像を挿入",
      replace: "交換",
      numberFormatList: "数値フォーマットリスト",
      bulletFormatList: "箇条書き形式リスト",
      audioReplace: "交換する",
      videoReplace: "交換する",
      videoAlign: "整列",
      videoDimension: "寸法",
      audioRemove: "取り除く",
      videoRemove: "取り除く",
      audioLayoutOption: "レイアウトオプション",
      videoLayoutOption: "レイアウトオプション",
      align: "整列",
      caption: "画像キャプション",
      remove: "削除する",
      insertLink: "リンクを挿入",
      display: "表示",
      altText: "代替テキスト",
      dimension: "サイズ変更",
      fullscreen: "最大化",
      maximize: "最大化",
      minimize: "最小化",
      lowerCase: "小文字",
      upperCase: "大文字",
      print: "印刷する",
      formats: "書式",
      sourcecode: "コードビュー",
      preview: "プレビュー",
      viewside: "ビューサイド",
      insertCode: "コードを挿入",
      linkText: "テキストを表示する",
      linkTooltipLabel: "題名",
      linkWebUrl: "ウェブアドレス",
      linkTitle: "タイトルを入力してください",
      linkurl: "https://example.com",
      linkOpenInNewWindow: "新しいウィンドウでリンクを開く",
      linkHeader: "リンクを挿入",
      dialogInsert: "インサート",
      dialogCancel: "キャンセル",
      dialogUpdate: "更新",
      imageHeader: "画像を挿入",
      audioHeader: "オーディオの挿入",
      videoHeader: "ビデオの挿入",
      imageLinkHeader: "Webからリンクを提供することもできます",
      audioLinkHeader: "Web からリンクを提供することもできます",
      videoLinkHeader: "ウェブURL",
      embedVideoLinkHeader: "メディア埋め込み URL",
      mdimageLink: "画像のURLを入力してください",
      imageUploadMessage:
        "ここに画像をドロップするか、参照してアップロードします",
      audioUploadMessage:
        "音声ファイルをドロップするか、参照してアップロードします",
      videoUploadMessage:
        "ビデオ ファイルをドロップするか、参照してアップロードします",
      imageDeviceUploadMessage: "ここをクリックしてアップロード",
      audioDeviceUploadMessage: "ここをクリックしてアップロードしてください",
      videoDeviceUploadMessage: "ここをクリックしてアップロードしてください",
      imageAlternateText: "代替テキスト",
      alternateHeader: "代替テキスト",
      browse: "ブラウズ",
      imageUrl: "https://example.com/image.png",
      audioUrl: "https://example.com/audio.mp3",
      videoUrl: "https://example.com/video.mp4",
      webUrl: "ウェブURL",
      embedUrl: "埋め込みコード",
      imageCaption: "キャプション",
      imageSizeHeader: "画像サイズ",
      imageHeight: "高さ",
      imageWidth: "幅",
      videoHeight: "身長",
      videoWidth: "幅",
      textPlaceholder: "テキストを入力してください",
      inserttablebtn: "テーブルを挿入",
      tabledialogHeader: "テーブルを挿入",
      tableWidth: "幅",
      cellpadding: "セルのパディング",
      cellspacing: "セル間隔",
      columns: "列の数",
      rows: "行の数",
      tableRows: "行",
      tableColumns: "カラム",
      tableCellHorizontalAlign: "テーブルセルの水平方向の整列",
      tableCellVerticalAlign: "テーブルの垂直方向の配置",
      createTable: "テーブルを作成",
      removeTable: "テーブルを削除",
      tableHeader: "ヘッダー行",
      tableRemove: "テーブルの削除",
      tableCellBackground: "テーブルセルの背景",
      tableEditProperties: "テーブル編集プロパティ",
      styles: "スタイル",
      insertColumnLeft: "列を左に挿入",
      insertColumnRight: "列を右に挿入",
      deleteColumn: "列を削除",
      insertRowBefore: "前に行を挿入",
      insertRowAfter: "後に行を挿入",
      deleteRow: "行を削除",
      tableEditHeader: "テーブルを編集",
      TableHeadingText: "見出し",
      TableColText: "コル",
      imageInsertLinkHeader: "リンクを挿入",
      editImageHeader: "画像を編集",
      alignmentsDropDownLeft: "左揃え",
      alignmentsDropDownCenter: "中央揃え",
      alignmentsDropDownRight: "右揃え",
      alignmentsDropDownJustify: "両端揃え",
      imageDisplayDropDownInline: "列をなして",
      imageDisplayDropDownBreak: "ブレーク",
      audioLayoutOptionDropDownInline: "列をなして",
      audioLayoutOptionDropDownBreak: "壊す",
      videoLayoutOptionDropDownInline: "列をなして",
      videoLayoutOptionDropDownBreak: "壊す",
      tableInsertRowDropDownBefore: "前に行を挿入",
      tableInsertRowDropDownAfter: "後に行を挿入",
      tableInsertRowDropDownDelete: "行を削除",
      tableInsertColumnDropDownLeft: "列を左に挿入",
      tableInsertColumnDropDownRight: "列を右に挿入",
      tableInsertColumnDropDownDelete: "列を削除",
      tableVerticalAlignDropDownTop: "上揃え",
      tableVerticalAlignDropDownMiddle: "中央揃え",
      tableVerticalAlignDropDownBottom: "下揃え",
      tableStylesDropDownDashedBorder: "破線枠",
      tableStylesDropDownAlternateRows: "代替行",
      pasteFormat: "形式を貼り付け",
      pasteFormatContent: "書式設定アクションを選択します",
      plainText: "プレーンテキスト",
      cleanFormat: "掃除",
      keepFormat: "保つ",
      pasteDialogOk: "OK",
      pasteDialogCancel: "キャンセル",
      fileManager: "ファイルマネージャー",
      fileDialogHeader: "ファイルブラウザ",
      formatsDropDownParagraph: "段落",
      formatsDropDownCode: "コード",
      formatsDropDownQuotation: "引用",
      formatsDropDownHeading1: "見出し1",
      formatsDropDownHeading2: "見出し2",
      formatsDropDownHeading3: "見出し3",
      formatsDropDownHeading4: "見出し4",
      fontNameSegoeUI: "SegoeUI",
      fontNameArial: "Arial",
      fontNameGeorgia: "Georgia",
      fontNameImpact: "Impact",
      fontNameTahoma: "Tahoma",
      fontNameTimesNewRoman: "Times New Roman",
      fontNameVerdana: "Verdana",
      formatsOLListNumber: "数",
      formatsOLListLowerAlpha: "下位アルファ",
      formatsOLListUpperAlpha: "アッパーアルファ",
      formatsOLListLowerRoman: "ローマ語",
      formatsOLListUpperRoman: "アッパーローマ",
      formatsOLListLowerGreek: "ローワーギリシャ語",
      formatsULListDisc: "ディスク",
      formatsULListCircle: "サークル",
      formatsULListSquare: "平方",
      formatsOLListNone: "無し",
      formatsULListNone: "無し",
      formatPainter: "フォーマットペインター",
      emojiPicker: "絵文字ピッカー",
      embeddedCode: "埋め込みコード",
      pasteEmbeddedCodeHere: "ここに埋め込みコードを貼り付けます",
      emojiPickerTypeToFind: "検索する文字を入力してください",
      emojiPickerNoResultFound: "結果が見つかりません",
      emojiPickerTrySomethingElse: "何か別のことを試してみる",
      linkAriaLabel: "新しいウィンドウで開きます",
      imageLinkAriaLabel: "新しいウィンドウで開きます",
      unsupportedImage: "サポートされていないファイル形式です",
      mergecells: "セルを結合します",
      verticalsplit: "垂直分割",
      horizontalsplit: "水平分割",
      numberFormatListLowerAlpha: "下位アルファ",
      numberFormatListUpperAlpha: "アッパーアルファ",
      numberFormatListLowerRoman: "ローワーローマン",
      numberFormatListUpperRoman: "アッパーローマ",
      numberFormatListLowerGreek: "下ギリシャ語",
      slashMenuItemHeadingOneText: "見出し1",
      slashMenuItemHeadingOneDescription:
        "これをトップレベルの見出しまたはタイトルに使用します。",
      slashMenuItemHeadingTwoText: "見出し2",
      slashMenuItemHeadingTwoDescription:
        "重要なセクションにこれを使用します。",
      slashMenuItemHeadingThreeText: "見出し 3",
      slashMenuItemHeadingThreeDescription:
        "これをサブセクションとグループの見出しに使用します。",
      slashMenuItemHeadingFourText: "見出し 4",
      slashMenuItemHeadingFourDescription:
        "サブトピックの要点を説明するためにこれを使用します。",
      slashMenuItemParagraphText: "段落",
      slashMenuItemParagraphDescription: "段落を使って書く。",
      slashMenuItemBlockquoteText: "ブロッククォート",
      slashMenuItemBlockquoteDescription: "引用または引用を作成します。",
      slashMenuItemOrderedListText: "順序付きリスト",
      slashMenuItemOrderedListDescription: "順序付きリストを作成します。",
      slashMenuItemUnorderedListText: "順序なしリスト",
      slashMenuItemUnorderedListDescription: "順序なしリストを作成します。",
      slashMenuItemCodeText: "コードブロック",
      slashMenuItemCodeDescription:
        "フォーマット済みのコード ブロックを作成します。",
      slashMenuItemTableText: "テーブル",
      slashMenuItemTableDescription: "テーブルを挿入します。",
      slashMenuItemLinkText: "リンク",
      slashMenuItemLinkDescription: "リンクを挿入します。",
      slashMenuItemImageText: "画像",
      slashMenuItemImageDescription: "画像を挿入します。",
      slashMenuItemAudioText: "オーディオ",
      slashMenuItemAudioDescription: "音声を挿入します。",
      slashMenuItemVideoText: "ビデオ",
      slashMenuItemVideoDescription: "ビデオを挿入します。",
      slashMenuItemEmojiText: "絵文字ピッカー",
      slashMenuItemEmojiDescription:
        "絵文字を使用してアイデアや絵文字を表現します。",
    },
    colorpicker: {
      Apply: "適用する",
      Cancel: "キャンセル",
      ModeSwitcher: "スイッチモード",
      RecentColors: "最近の色",
    },
    uploader: {
      Browse: "ブラウズ...",
      Clear: "晴れ",
      Upload: "アップロードする",
      dropFilesHint: "またはここにファイルをドロップします",
      invalidMaxFileSize: "ファイルサイズが大きすぎます",
      invalidMinFileSize: "ファイルサイズが小さすぎます",
      invalidFileType: "ファイルタイプは許可されていません",
      uploadFailedMessage: "ファイルをアップロードできませんでした",
      uploadSuccessMessage: "ファイルが正常にアップロードされました",
      removedSuccessMessage: "ファイルは正常に削除されました",
      removedFailedMessage: "ファイルを削除できません",
      inProgress: "アップロード中",
      readyToUploadMessage: "アップロードする準備ができました",
      abort: "アボート",
      remove: "削除する",
      cancel: "キャンセル",
      delete: "ファイルを削除する",
      pauseUpload: "ファイルのアップロードが一時停止しました",
      pause: "一時停止",
      resume: "履歴書",
      retry: "リトライ",
      fileUploadCancel: "ファイルのアップロードがキャンセルされました",
    },
    numerictextbox: {
      incrementTitle: "増分値",
      decrementTitle: "デクリメント値",
    },
    slider: {
      incrementTitle: "増加する",
      decrementTitle: "減少",
    },
    formValidator: {
      required: "この項目は必須です。",
      email: "有効なメールアドレスを入力してください。",
      url: "有効なURLを入力してください。",
      date: "有効な日付を入力してください。",
      dateIso: "有効な日付（ISO）を入力してください。",
      creditcard: "有効なカード番号を入力してください",
      number: "有効な数値を入力してください。",
      digits: "数字のみ入力して下さい。",
      maxLength: "{0}文字以内で入力してください。",
      minLength: "少なくとも{0}文字を入力してください。",
      rangeLength: "{0}〜{1}文字の値を入力してください。",
      range: "{0}〜{1}の値を入力してください。",
      max: "{0}以下の値を入力してください。",
      min: "{0}以上の値を入力してください。",
      regex: "正しい値を入力してください。",
      tel: "有効な電話番号を入力して下さい。",
      pattern: "正しいパターン値を入力してください。",
      equalTo: "有効な一致テキストを入力してください",
    },
    treegrid: {
      Above: "上",
      Below: "未満",
      AddRow: "行を追加する",
      ExpandAll: "すべて展開",
      CollapseAll: "すべて折りたたむ",
    },
    querybuilder: {
      StartsWith: "〜で始まる",
      EndsWith: "次で終わる",
      Contains: "含む",
      NotLike: "含む",
      Like: "みたいではなく",
      Equal: "等しい",
      NotEqual: "等しくない",
      LessThan: "未満",
      LessThanOrEqual: "より小さいか等しい",
      GreaterThan: "より大きい",
      GreaterThanOrEqual: "より大きいか等しい",
      Between: "の間に",
      NotBetween: "間にない",
      Empty: "空の",
      NotEmpty: "空ではない",
      In: "に",
      NotIn: "ありませんで",
      NotContains: "含まない",
      Remove: "削除する",
      SelectField: "フィールドを選択してください",
      SelectOperator: "選択演算子",
      DeleteRule: "この条件を削除",
      DeleteGroup: "グループを削除",
      AddGroup: "グループを追加",
      AddCondition: "条件を追加",
      Edit: "編集",
      ValidationMessage: "この項目は必須です",
      SummaryViewTitle: "概要ビュー",
      OtherFields: "その他の分野",
      AND: "そして",
      OR: "または",
      SelectValue: "値を入力",
      IsEmpty: "空です",
      IsNotEmpty: "空ではない",
      IsNull: "無効である",
      IsNotNull: "ヌルではない",
      True: "真実",
      False: "間違い",
      DoesNotStartWith: "で始まらない",
      DoesNotEndWith: "で終わらない",
      DoesNotContain: "含まれていない",
      AddButton: "グループ/条件の追加",
      CloneGroup: "クローングループ",
      LockGroup: "ロックグループ",
      CloneRule: "クローンルール",
      LockRule: "ロックルール",
      UnlockRule: "ロック解除ルール",
      UnlockGroup: "グループのロックを解除する",
    },
    barcode: {},
    datamatrix: {},
    qrcode: {},
    pivotview: {
      applyToGrandTotal: "総計に適用する",
      grandTotal: "総計",
      total: "合計",
      value: "値",
      noValue: "値なし",
      row: "行",
      column: "カラム",
      collapse: "崩壊",
      expand: "展開する",
      rowAxisPrompt: "ここに行をドロップ",
      columnAxisPrompt: "ここに列をドロップします",
      valueAxisPrompt: "ここに値をドロップ",
      filterAxisPrompt: "ここにフィルターをドロップ",
      filter: "フィルタ",
      filtered: "フィルター済み",
      sort: "ソート",
      filters: "フィルター",
      rows: "行",
      columns: "列",
      values: "値",
      close: "閉じる",
      cancel: "キャンセル",
      delete: "削除",
      CalculatedField: "計算フィールド",
      createCalculatedField: "計算フィールドを作成する",
      fieldName: "フィールド名を入力してください",
      error: "エラー",
      invalidFormula: "数式が無効です。",
      dropText: "例：（ 'Sum（Order_Count）' + 'Sum（In_Stock）'）* 250",
      dropTextMobile: "ここでフィールドを追加し、式を編集します。",
      dropAction: "計算フィールドは、値軸以外の領域には配置できません。",
      alert: "アラート",
      warning: "警告",
      ok: "OK",
      search: "探す",
      drag: "引っ張る",
      remove: "削除する",
      allFields: "すべてのフィールド",
      formula: "式",
      addToRow: "行に追加",
      addToColumn: "列に追加",
      addToValue: "付加価値",
      addToFilter: "フィルターに追加",
      emptyData: "表示するレコードはありません",
      fieldExist:
        "この名前のフィールドは既に存在します。別の名前を入力してください。",
      confirmText:
        "この名前には計算フィールドが既に存在します。取り替えたいですか？",
      noMatches: "一致なし",
      format: "集計値",
      edit: "編集",
      clear: "晴れ",
      formulaField: "フィールドを数式にドラッグアンドドロップする",
      dragField: "フィールドを数式にドラッグします",
      clearFilter: "晴れ",
      by: "沿って",
      all: "すべて",
      multipleItems: "複数のアイテム",
      member: "メンバー",
      label: "ラベル",
      date: "日付",
      enterValue: "値を入力してください",
      chooseDate: "日付を入力してください",
      Before: "前",
      BeforeOrEqualTo: "前または等しい",
      After: "後",
      AfterOrEqualTo: "後または等しい",
      labelTextContent: "ラベルのあるアイテムを表示する",
      dateTextContent: "日付のあるアイテムを表示する",
      valueTextContent: "対象のアイテムを表示",
      Equals: "等しい",
      DoesNotEquals: "等しくない",
      BeginWith: "〜で始まる",
      DoesNotBeginWith: "次で始まらない",
      EndsWith: "次で終わる",
      DoesNotEndsWith: "で終わらない",
      Contains: "含む",
      DoesNotContains: "含まない",
      GreaterThan: "より大きい",
      GreaterThanOrEqualTo: "以上",
      LessThan: "未満",
      LessThanOrEqualTo: "より小さいか等しい",
      Between: "の間に",
      NotBetween: "間にない",
      And: "そして",
      Sum: "和",
      Count: "カウント",
      DistinctCount: "明確なカウント",
      Product: "製品",
      Avg: "平均",
      Min: "分",
      SampleVar: "サンプル変数",
      PopulationVar: "母集団変数",
      RunningTotals: "積算合計",
      Max: "マックス",
      Index: "索引",
      SampleStDev: "サンプルStDev",
      PopulationStDev: "人口StDev",
      PercentageOfRowTotal: "行合計の％",
      PercentageOfParentTotal: "親全体の割合",
      PercentageOfParentColumnTotal: "親列の合計の割合",
      PercentageOfParentRowTotal: "親行合計の割合",
      DifferenceFrom: "との違い",
      PercentageOfDifferenceFrom: "差の％",
      PercentageOfGrandTotal: "総計に対する割合",
      PercentageOfColumnTotal: "列合計の％",
      NotEquals: "等しくない",
      AllValues: "すべての値",
      conditionalFormatting: "条件付き書式",
      apply: "適用する",
      condition: "条件を追加",
      formatLabel: "フォーマット",
      valueFieldSettings: "値フィールドの設定",
      baseField: "ベースフィールド：",
      baseItem: "ベースアイテム：",
      summarizeValuesBy: "値を要約する：",
      sourceName: "フィールド名 ：",
      sourceCaption: "フィールドキャプション：",
      example: "例えば：",
      editorDataLimitMsg: " より多くのアイテム。検索してさらに絞り込みます。",
      details: "詳細",
      manageRecords: "レコードを管理する",
      Years: "年数",
      Quarters: "四分の一",
      Months: "ヶ月",
      Days: "日々",
      Hours: "時間",
      Minutes: "議事録",
      Seconds: "秒",
      save: "レポートを保存する",
      new: "新しいレポートを作成する",
      load: "負荷",
      saveAs: "現在のレポートとして保存",
      rename: "現在のレポートの名前を変更する",
      deleteReport: "現在のレポートを削除する",
      export: "書き出す",
      subTotals: "小計",
      grandTotals: "総計",
      reportName: "レポート名：",
      pdf: "PDF",
      excel: "エクセル",
      csv: "CSV",
      png: "PNG",
      jpeg: "JPEG",
      svg: "SVG",
      mdxQuery: "MDXクエリ",
      showSubTotals: "小計を表示",
      doNotShowSubTotals: "小計を表示しない",
      showSubTotalsRowsOnly: "小計行のみを表示",
      showSubTotalsColumnsOnly: "小計列のみを表示",
      showGrandTotals: "総計を表示する",
      doNotShowGrandTotals: "総計を表示しない",
      showGrandTotalsRowsOnly: "総計行のみを表示",
      showGrandTotalsColumnsOnly: "総計列のみを表示",
      fieldList: "フィールドリストを表示",
      grid: "表を表示",
      toolbarFormatting: "条件付き書式",
      chart: "チャート",
      reportMsg: "有効なレポート名を入力してください!!!",
      reportList: "レポート一覧",
      removeConfirm: "このレポートを削除してもよろしいですか？",
      emptyReport: "レポートが見つかりません!!",
      bar: "バー",
      line: "ライン",
      area: "範囲",
      scatter: "散布",
      polar: "極地",
      of: "の",
      emptyFormat: "フォーマットが見つかりません!!!",
      emptyInput: "値を入力してください",
      newReportConfirm: "レポートへの変更を保存しますか？",
      emptyReportName: "レポート名を入力してください",
      qtr: "四半期",
      null: "ヌル",
      undefined: "未定義",
      groupOutOfRange: "範囲外",
      fieldDropErrorAction:
        "移動しているフィールドは、レポートのその領域に配置できません",
      MoreOption: "もっと...",
      aggregate: "集計",
      drillThrough: "ドリルスルー",
      ascending: "上昇",
      descending: "降順",
      number: "数",
      currency: "通貨",
      percentage: "割合",
      formatType: "フォーマットタイプ",
      customText: "通貨記号",
      symbolPosition: "シンボルの位置",
      left: "左",
      right: "正しい",
      grouping: "グルーピング",
      true: "本当だ",
      false: "偽",
      decimalPlaces: "小数位",
      numberFormat: "数値のフォーマット",
      memberType: "フィールドタイプ",
      formatString: "フォーマット文字列",
      expressionField: "表現",
      customFormat: "カスタム形式の文字列を入力してください",
      selectedHierarchy: "親階層",
      olapDropText:
        "例：[メジャー]。[注文数量] +（[メジャー]。[注文数量] * 0.10）",
      Percent: "パーセント",
      Custom: "カスタム",
      Measure: "測定する",
      Dimension: "寸法",
      Standard: "標準",
      blank: "（ブランク）",
      fieldTooltip:
        "フィールドをドラッグアンドドロップして式を作成します。そして、既存の計算フィールドを編集したい場合！次に、「計算されるメンバー」の下のフィールドを選択するだけでそれを実現できます。",
      QuarterYear: "四半期",
      fieldTitle: "フィールド名",
      drillError: "計算フィールドの未加工アイテムを表示できません。",
      caption: "フィールドキャプション",
      copy: "コピー",
      defaultReport: "デフォルトのレポート",
      customFormatString: "カスタムフォーマット",
      invalidFormat: "無効な形式。",
      group: "グループ",
      unGroup: "グループ解除",
      invalidSelection: "その選択をグループ化できません。",
      groupName: "ヘッダーに表示するキャプションを入力してください",
      captionName: "グループフィールドのキャプションを入力します",
      selectedItems: "選択したアイテム",
      groupFieldCaption: "フィールドキャプション",
      groupTitle: "グループ名",
      startAt: "で始まる",
      endAt: "で終わる",
      groupBy: "間隔",
      selectGroup: "グループを選択",
      numberFormatString: "例：C、P、0000％、### 0。## 0＃など",
      stackingcolumn: "積み上げコラム",
      stackingbar: "積み上げ棒",
      stackingarea: "積み上げ面",
      stepline: "ステップライン",
      steparea: "ステップエリア",
      splinearea: "スプライン領域",
      spline: "スプライン",
      stackingcolumn100: "100％積み上げカラム",
      stackingbar100: "100％積み上げバー",
      stackingarea100: "100％積み上げ面",
      bubble: "バブル",
      pareto: "パレート",
      radar: "レーダー",
      chartTypeSettings: "チャートタイプの設定",
      multipleAxes: "複数の軸",
      sortAscending: "昇順で並べ替え",
      sortDescending: "降順で並べ替え",
      sortNone: "データの並べ替え",
      clearCalculatedField: "編集したフィールド情報をクリア",
      editCalculatedField: "計算フィールドを編集する",
      ChartType: "チャートタイプ",
      yes: "はい",
      no: "番号",
      numberFormatMenu: "数値のフォーマット...",
      conditionalFormattingMenu: "条件付き書式...",
      removeCalculatedField: "この計算フィールドを削除してもよろしいですか？",
      replaceConfirmBefore: "というレポート",
      replaceConfirmAfter: " もう存在している。取り替えたいですか？",
      pie: "パイ",
      funnel: "漏斗",
      doughnut: "ドーナツ",
      pyramid: "ピラミッド",
      showLegend: "凡例を表示",
      exit: "出口",
      invalidJSON: "無効なJSONデータ",
      invalidCSV: "無効なCSVデータ",
      stacked: "積み上げ",
      single: "シングル",
      multipleAxisMode: "多軸モード",
      grandTotalPosition: "総計ポジション",
      top: "上",
      bottom: "下",
      None: "なし",
      stackingline: "スタックライン",
      stackingline100: "100％スタックライン",
      rowPage: "行ページャー",
      rowPerPage: "ページあたりの行数",
      columnPage: "列ページャー",
      columnPerPage: "ページあたりの列",
      goToFirstPage: "最初のページに移動",
      goToPreviousPage: "前のページへ",
      goToNextPage: "次のページへ",
      goToLastPage: "最後のページへ",
      combined: "組み合わせた",
      subTotalPosition: "小計位置",
      auto: "自動",
      loading: "読み込み中...",
      add: "追加",
    },
    pivotfieldlist: {
      staticFieldList: "ピボットフィールドリスト",
      fieldList: "フィールドリスト",
      dropFilterPrompt: "ここにフィルターをドロップ",
      dropColPrompt: "ここに列をドロップします",
      dropRowPrompt: "ここに行をドロップ",
      dropValPrompt: "ここに値をドロップ",
      addPrompt: "ここにフィールドを追加",
      adaptiveFieldHeader: "フィールドを選択",
      centerHeader: "下の軸間でフィールドをドラッグします。",
      add: "追加",
      drag: "引っ張る",
      filter: "フィルタ",
      filtered: "フィルター済み",
      sort: "ソート",
      remove: "削除する",
      filters: "フィルター",
      rows: "行",
      columns: "列",
      values: "値",
      CalculatedField: "計算フィールド",
      createCalculatedField: "計算フィールドを作成する",
      fieldName: "フィールド名を入力してください",
      error: "エラー",
      invalidFormula: "数式が無効です。",
      dropText: "例：（ 'Sum（Order_Count）' + 'Sum（In_Stock）' '）* 250",
      dropTextMobile: "ここでフィールドを追加し、式を編集します。",
      dropAction: "計算フィールドは、値軸以外の領域には配置できません。",
      search: "探す",
      close: "閉じる",
      cancel: "キャンセル",
      delete: "削除",
      alert: "アラート",
      warning: "警告",
      ok: "OK",
      allFields: "すべてのフィールド",
      formula: "式",
      fieldExist:
        "この名前のフィールドは既に存在します。別の名前を入力してください。",
      confirmText:
        "この名前には計算フィールドが既に存在します。取り替えたいですか？",
      noMatches: "一致なし",
      format: "集計値",
      edit: "編集",
      clear: "晴れ",
      formulaField: "フィールドを数式にドラッグアンドドロップする",
      dragField: "フィールドを数式にドラッグします",
      clearFilter: "晴れ",
      by: "沿って",
      enterValue: "値を入力してください",
      chooseDate: "日付を入力してください",
      all: "すべて",
      multipleItems: "複数のアイテム",
      Equals: "等しい",
      DoesNotEquals: "等しくない",
      BeginWith: "〜で始まる",
      DoesNotBeginWith: "次で始まらない",
      EndsWith: "次で終わる",
      DoesNotEndsWith: "で終わらない",
      Contains: "含む",
      DoesNotContains: "含まない",
      GreaterThan: "より大きい",
      GreaterThanOrEqualTo: "以上",
      LessThan: "未満",
      LessThanOrEqualTo: "より小さいか等しい",
      Between: "の間に",
      NotBetween: "間にない",
      Before: "前",
      BeforeOrEqualTo: "前または等しい",
      After: "後",
      AfterOrEqualTo: "後または等しい",
      member: "メンバー",
      label: "ラベル",
      date: "日付",
      value: "値",
      labelTextContent: "ラベルのあるアイテムを表示する",
      dateTextContent: "日付のあるアイテムを表示する",
      valueTextContent: "対象のアイテムを表示",
      And: "そして",
      Sum: "和",
      Count: "カウント",
      DistinctCount: "明確なカウント",
      Product: "製品",
      Avg: "平均",
      Min: "分",
      Max: "マックス",
      Index: "索引",
      SampleStDev: "サンプルStDev",
      PopulationStDev: "人口StDev",
      SampleVar: "サンプル変数",
      PopulationVar: "母集団変数",
      RunningTotals: "積算合計",
      DifferenceFrom: "との違い",
      PercentageOfDifferenceFrom: "差の％",
      PercentageOfGrandTotal: "総計に対する割合",
      PercentageOfColumnTotal: "列合計の％",
      PercentageOfRowTotal: "行合計の％",
      PercentageOfParentTotal: "親全体の割合",
      PercentageOfParentColumnTotal: "親列の合計の割合",
      PercentageOfParentRowTotal: "親行合計の割合",
      Years: "年数",
      Quarters: "四分の一",
      Months: "ヶ月",
      Days: "日々",
      Hours: "時間",
      Minutes: "議事録",
      Seconds: "秒",
      apply: "適用する",
      valueFieldSettings: "値フィールドの設定",
      sourceName: "フィールド名 ：",
      sourceCaption: "フィールドキャプション：",
      summarizeValuesBy: "値を要約する：",
      baseField: "ベースフィールド：",
      baseItem: "ベースアイテム：",
      example: "例えば：",
      editorDataLimitMsg: " より多くのアイテム。検索してさらに絞り込みます。",
      deferLayoutUpdate: "レイアウト更新の延期",
      null: "ヌル",
      undefined: "未定義",
      groupOutOfRange: "範囲外",
      fieldDropErrorAction:
        "移動しているフィールドは、レポートのその領域に配置できません",
      MoreOption: "もっと...",
      memberType: "フィールドタイプ",
      selectedHierarchy: "親階層",
      formatString: "フォーマット文字列",
      expressionField: "表現",
      olapDropText:
        "例：[メジャー]。[注文数量] +（[メジャー]。[注文数量] * 0.10）",
      customFormat: "カスタム形式の文字列を入力してください",
      Measure: "測定する",
      Dimension: "寸法",
      Standard: "標準",
      Currency: "通貨",
      Percent: "パーセント",
      Custom: "カスタム",
      blank: "（ブランク）",
      fieldTooltip:
        "フィールドをドラッグアンドドロップして式を作成します。そして、既存の計算フィールドを編集したい場合！ 「Calculated Members」の下のフィールドを選択するだけで実現できます。",
      fieldTitle: "フィールド名",
      QuarterYear: "四半期",
      caption: "フィールドキャプション",
      copy: "コピー",
      group: "グループ",
      numberFormatString: "例：C、P、0000％、### 0。## 0＃など。",
      sortAscending: "昇順で並べ替え",
      sortDescending: "降順で並べ替え",
      sortNone: "データの並べ替え",
      clearCalculatedField: "編集したフィールド情報をクリア",
      editCalculatedField: "計算フィールドを編集する",
      selectGroup: "グループを選択",
      of: "の",
      removeCalculatedField: "この計算フィールドを削除してもよろしいですか？",
      yes: "はい",
      no: "番号",
      None: "なし",
    },
    pdfviewer: {
      PdfViewer: "PDFビューアー",
      Cancel: "キャンセル",
      "Download file": "ダウンロードファイル",
      Download: "ダウンロード",
      "Enter Password":
        "このドキュメントはパスワードで保護されています。パスワードを入力して下さい。",
      "File Corrupted": "ファイルが破損した",
      "File Corrupted Content":
        "ファイルが破損しており、開くことができません。",
      "Fit Page": "ページに合わせる",
      "Fit Width": "フィット幅",
      Automatic: "自動",
      "Go To First Page": "最初のページを表示",
      "Invalid Password": "間違ったパスワード。もう一度やり直してください。",
      "Next Page": "次のページを表示",
      OK: "わかった",
      Open: "ファイルを開く",
      "Page Number": "現在のページ番号",
      "Previous Page": "前のページを表示",
      "Go To Last Page": "最後のページを表示",
      Zoom: "ズーム",
      "Zoom In": "ズームイン",
      "Zoom Out": "ズームアウトする",
      "Page Thumbnails": "ページのサムネイル",
      Bookmarks: "しおり",
      Print: "印刷ファイル",
      "Password Protected": "パスワードが必要",
      Copy: "コピー",
      "Text Selection": "テキスト選択ツール",
      Panning: "パンモード",
      "Text Search": "テキストを検索",
      "Find in document": "ドキュメントで検索",
      "Match case": "マッチケース",
      Apply: "適用する",
      GoToPage: "ページに移動",
      "No matches":
        "ビューアはドキュメントの検索を終了しました。一致するものはもう見つかりませんでした",
      "No Text Found": "テキストが見つかりません",
      Undo: "元に戻す",
      Redo: "やり直し",
      Annotation: "注釈を追加または編集する",
      Highlight: "ハイライトテキスト",
      Underline: "テキストに下線を引く",
      Strikethrough: "取り消し線テキスト",
      Delete: "注釈を削除",
      Opacity: "不透明度",
      "Color edit": "色を変える",
      "Opacity edit": "不透明度を変更",
      "Highlight context": "ハイライト",
      "Underline context": "下線",
      "Strikethrough context": "取り消し線",
      "Server error":
        "Webサービスはリッスンしていません。 PDF Viewerは、すべての機能がWebサービスに依存しています。続行するには、Webサービスを開始してください。",
      "Open text": "開いた",
      "First text": "先頭ページ",
      "Previous text": "前のページ",
      "Next text": "次のページ",
      "Last text": "最後のページ",
      "Zoom in text": "ズームイン",
      "Zoom out text": "ズームアウトする",
      "Selection text": "選択",
      "Pan text": "パン",
      "Print text": "印刷する",
      "Search text": "探す",
      "Annotation Edit text": "注釈を編集",
      "Line Thickness": "線の太さ",
      "Line Properties": "線のプロパティ",
      "Start Arrow": "開始矢印",
      "End Arrow": "終了矢印",
      "Line Style": "線のスタイル",
      "Fill Color": "塗りつぶしの色",
      "Line Color": "線の色",
      None: "なし",
      "Open Arrow": "開いた",
      "Closed Arrow": "閉まっている",
      "Round Arrow": "円形",
      "Square Arrow": "平方",
      "Diamond Arrow": "ダイヤモンド",
      Butt: "お尻",
      Cut: "切る",
      Paste: "ペースト",
      "Delete Context": "削除",
      Properties: "プロパティ",
      "Add Stamp": "スタンプを追加",
      "Add Shapes": "シェイプを追加",
      "Stroke edit": "ストロークの色を変更",
      "Change thickness": "境界線の太さを変更する",
      "Add line": "行を追加",
      "Add arrow": "矢印を追加",
      "Add rectangle": "長方形を追加",
      "Add circle": "サークルを追加",
      "Add polygon": "ポリゴンを追加",
      "Add Comments": "コメントを追加",
      Comments: "コメント",
      "No Comments Yet": "コメントはまだありません",
      Accepted: "受け入れられた",
      Completed: "完成しました",
      Cancelled: "キャンセル",
      Rejected: "拒否されました",
      "Leader Length": "リーダーの長さ",
      "Scale Ratio": "スケール比",
      Calibrate: "調整する",
      "Calibrate Distance": "距離の調整",
      "Calibrate Perimeter": "周囲のキャリブレーション",
      "Calibrate Area": "キャリブレーションエリア",
      "Calibrate Radius": "半径の調整",
      "Calibrate Volume": "ボリュームの調整",
      highlight: "ハイライト",
      underline: "下線",
      strikethrough: "取り消し線",
      "Seach text": "探す",
      FormDesigner: "フォーム フィールドの追加と編集",
      "Client error":
        "クライアント側のエラーが見つかりました。 AjaxRequestSettings プロパティで提供されるカスタム ヘッダーと、ServerActionSettings プロパティの Web アクション メソッドを確認してください。.",
      "FormDesigner Edit text": "フォーム フィールドの追加と編集",
      SubmitForm: "フォームを送信",
      Depth: "深さ",
      Closed: "閉まっている",
      Round: "円形",
      Square: "平方",
      Diamond: "ダイヤモンド",
      Edit: "編集",
      Comment: "コメント",
      "Comment Panel": "コメントパネル",
      "Set Status": "ステータスの設定",
      Post: "役職",
      Page: "ページ",
      "Add a comment": "コメントを追加",
      "Add a reply": "返信を追加する",
      "Import Annotations": "JSONファイルから注釈をインポートする",
      "Export Annotations": "注釈をJSONファイルにエクスポートする",
      "Export XFDF": "XFDFファイルに注釈をエクスポートする",
      "Import XFDF": "XFDFファイルから注釈をインポートする",
      Add: "追加",
      Clear: "晴れ",
      Bold: "大胆な",
      Italic: "イタリック",
      Strikethroughs: "取り消し線",
      Underlines: "下線を引く",
      Superscript: "上付き文字",
      Subscript: "添字",
      "Align left": "左揃え",
      "Align right": "右揃え",
      Center: "センター",
      Justify: "正当化する",
      "Font color": "フォントの色",
      "Text Align": "テキストの整列",
      "Text Properties": "フォントスタイル",
      SignatureFieldDialogHeaderText: "署名を追加する",
      HandwrittenSignatureDialogHeaderText: "署名を追加する",
      InitialFieldDialogHeaderText: "イニシャルを追加",
      HandwrittenInitialDialogHeaderText: "イニシャルを追加",
      "Draw Ink": "インクを引く",
      Create: "作成する",
      "Font family": "フォントファミリー",
      "Font size": "フォントサイズ",
      "Free Text": "フリーテキスト",
      "Import Failed":
        "無効なJSONファイルタイプまたはファイル名。有効なJSONファイルを選択してください",
      "File not found":
        "インポートされたJSONファイルが目的の場所に見つかりません",
      "Export Failed":
        "注釈のエクスポートアクションが失敗しました。注釈が適切に追加されていることを確認してください",
      of: "の ",
      Dynamic: "動的",
      "Standard Business": "標準的なビジネス",
      "Sign Here": "ここにサインしてください",
      "Custom Stamp": "カスタムスタンプ",
      "Enter Signature as Name": "あなたの名前を入力してください",
      "Draw-hand Signature": "ドロー",
      "Type Signature": "タイプ",
      "Upload Signature": "アップロード",
      "Browse Signature Image": "ブラウズ",
      "Save Signature": "署名を保存",
      "Save Initial": "初期値を保存",
      Textbox: "テキストボックス",
      Password: "パスワード",
      "Check Box": "チェックボックス",
      "Radio Button": "ラジオボタン",
      Dropdown: "落ちる",
      "List Box": "リストボックス",
      Signature: "サイン",
      "Delete FormField": "フォーム フィールドの削除",
      "Textbox Properties": "テキストボックスのプロパティ",
      Name: "名前",
      Tooltip: "ツールチップ",
      Value: "価値",
      "Form Field Visibility": "フォーム フィールドの可視性",
      "Read Only": "読み取り専用",
      Required: "必須",
      Checked: "チェック済み",
      "Show Printing": "ショーの印刷",
      Formatting: "フォーマット",
      Fill: "塗りつぶし",
      Border: "国境",
      "Border Color": "ボーダの色",
      Thickness: "厚さ",
      "Max Length": "最大長",
      "List Item": "項目名",
      "Export Value": "アイテムの価値",
      "Dropdown Item List": "ドロップダウン項目一覧",
      "List Box Item List": "リストボックス項目一覧",
      General: "全般的",
      Appearance: "外観",
      Options: "オプション",
      "Delete Item": "消去",
      Up: "上",
      Down: "下",
      Multiline: "マルチライン",
      Revised: "改訂",
      Reviewed: "審査",
      Received: "受け取った",
      Confidential: "機密",
      Approved: "承認済み",
      "Not Approved": "未承認",
      Witness: "目撃者",
      "Initial Here": "イニシャルはこちら",
      Draft: "下書き",
      Final: "最後の",
      "For Public Release": "公開用",
      "Not For Public Release": "非公開",
      "For Comment": "コメント用",
      Void: "空所",
      "Preliminary Results": "暫定結果",
      "Information Only": "情報提供のみ",
      in: "の",
      m: "メートル",
      ft_in: "ft_in",
      ft: "フィート",
      p: "p",
      cm: "cm",
      mm: "んん",
      pt: "ポイント",
      cu: "キュ",
      sq: "平方",
      Initial: "イニシャル",
    },
    diagram: {
      Copy: "コピー",
      Cut: "切る",
      Paste: "ペースト",
      Undo: "元に戻す",
      Redo: "やり直し",
      SelectAll: "すべて選択",
      Grouping: "グルーピング",
      Group: "グループ",
      UnGroup: "グループ解除",
      Order: "注文",
      BringToFront: "前に持ってくる",
      MoveForward: "前進する",
      SendToBack: "後ろに送る",
      SendBackward: "後方に送ります",
    },
    "inplace-editor": {
      save: "セーブ",
      cancel: "キャンセル",
      loadingText: "読み込み中...",
      editIcon: "クリックして編集する",
      editAreaClick: "クリックして編集する",
      editAreaDoubleClick: "ダブルクリックして編集します",
    },
    drawing: {},
    "drop-down-base": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "リクエストに失敗しました",
    },
    chart: {
      Zoom: "ズーム",
      ZoomIn: "ズームイン",
      ZoomOut: "ズームアウトする",
      Reset: "リセットする",
      Pan: "パン",
      ResetZoom: "ズームをリセット",
    },
    maps: {
      Zoom: "ズーム",
      ZoomIn: "ズームイン",
      ZoomOut: "ズームアウトする",
      Reset: "リセットする",
      Pan: "パン",
      ResetZoom: "ズームをリセット",
      ImageNotFound: "画像が見つかりません",
    },
    "drop-down-tree": {
      noRecordsTemplate: "レコードが見つかりません",
      actionFailureTemplate: "要求が失敗しました",
      overflowCountTemplate: "+ ${count}もっと..",
      totalCountTemplate: "${count}が選択されました",
    },
    documenteditor: {
      Table: "テーブル",
      Row: "行",
      Cell: "細胞",
      Ok: "OK",
      Apply: "ゆっくりと簡単に",
      Cancel: "キャンセル",
      Size: "サイズ",
      "Preferred Width": "優先幅",
      Points: "ポイント",
      Percent: "パーセント",
      "Measure in": "で測定",
      Alignment: "アライメント",
      Left: "左",
      Center: "センター",
      Right: "正しい",
      Decimal: "小数点第1位付き",
      Bar: "セミ",
      Leader: "システム管理者",
      Tab: "未払いの請求書",
      BookMarkList: "マークされたドキュメントのリスト。",
      TabMarkList: "段落内のページをリストします。",
      "Tab stop position": "ディスク領域",
      "Default tab stops": "普通ではないゴーカート",
      "Tab stops to be cleared": "交換可能なカード",
      Tabs: "タブウィンドウ",
      Set: "使用法",
      Clear: "透明",
      "Clear All": "すべてを削除します",
      Justify: "正当化",
      "Indent from left": "左からインデント",
      "Borders and Shading": "ボーダーとシェーディング",
      Options: "オプション",
      "Specify height": "高さを指定",
      "At least": "少なくとも",
      Exactly: "丁度",
      "Row height is": "行の高さは",
      "Allow row to break across pages": "行がページ間で分割できるようにする",
      "Repeat as header row at the top of each page":
        "各ページの上部にヘッダー行として繰り返します",
      "Vertical alignment": "垂直方向の配置",
      Top: "上",
      Bottom: "底",
      "Default cell margins": "デフォルトのセルマージン",
      "Default cell spacing": "デフォルトのセル間隔",
      "Allow spacing between cells": "セル間の間隔を許可する",
      "Cell margins": "セルの余白",
      "Same as the whole table": "テーブル全体と同じ",
      Borders: "ボーダーズ",
      None: "なし",
      Style: "スタイル",
      Width: "幅",
      Height: "高さ",
      Letter: "文字",
      Tabloid: "タブロイド",
      Legal: "法的",
      Statement: "ステートメント",
      Executive: "エグゼクティブ",
      A3: "A3",
      A4: "A4",
      A5: "A5",
      B4: "B4",
      B5: "B5",
      "Custom Size": "カスタムサイズ",
      "Different odd and even": "奇数と偶数が異なる",
      "Different first page": "別の最初のページ",
      "From edge": "端から",
      Header: "ヘッダ",
      Footer: "フッター",
      "First Page Header": "最初のページのヘッダー",
      "First Page Footer": "最初のページのフッター",
      "Even Page Header": "ページヘッダーも",
      "Even Page Footer": "ページフッターも",
      "Odd Page Header": "奇数ページヘッダー",
      "Odd Page Footer": "奇数ページのフッター",
      "Same as Previous": "前回と同じ",
      Section: "セクション",
      Margin: "マージン",
      Paper: "論文",
      Layout: "レイアウト",
      Orientation: "オリエンテーション",
      Landscape: "風景",
      Portrait: "肖像画",
      "Show page numbers": "ページ番号を表示する",
      "Right align page numbers": "ページ番号を右揃え",
      Nothing: "なし",
      "Tab leader": "タブリーダー",
      "Show levels": "レベルを表示",
      "Use hyperlinks instead of page numbers":
        "ページ番号の代わりにハイパーリンクを使用する",
      "Build table of contents from": "目次の作成",
      Styles: "スタイル",
      "Available styles": "利用可能なスタイル",
      "TOC level": "TOCレベル",
      Heading: "見出し",
      "Heading 1": "見出し1",
      "Heading 2": "見出し2",
      "Heading 3": "見出し3",
      "Heading 4": "見出し4",
      "Heading 5": "見出し5",
      "Heading 6": "見出し6",
      "List Paragraph": "リスト段落",
      Normal: "普通",
      "Outline levels": "アウトラインレベル",
      "Table entry fields": "テーブル入力フィールド",
      Modify: "変更する",
      Color: "色",
      Setting: "設定",
      Box: "ボックス",
      All: "すべて",
      Custom: "カスタム",
      Preview: "プレビュー",
      Shading: "シェーディング",
      Fill: "塗りつぶし",
      "Apply To": "に適用",
      "Table Properties": "テーブルのプロパティ",
      "Cell Options": "セルオプション",
      "Table Options": "テーブルオプション",
      "Insert Table": "テーブルを挿入",
      "Number of columns": "列の数",
      "Number of rows": "行の数",
      "Text to display": "表示するテキスト",
      "ScreenTip text": "ヒントのテキスト",
      Address: "住所",
      "Insert Hyperlink": "ハイパーリンクを挿入",
      "Edit Hyperlink": "ハイパーリンクを編集",
      Insert: "インサート",
      General: "全般",
      "The number must be between": "数値は 1 ～ 9 でなければなりません",
      "The Invalid number": "これは有効な番号ではありません",
      Indentation: "くぼみ",
      "Before text": "テキストの前",
      Special: "特別",
      "First line": "最初の行",
      Hanging: "ぶら下げ",
      "After text": "テキストの後",
      By: "沿って",
      Before: "前",
      "Line Spacing": "行間隔",
      After: "後",
      At: "で",
      Multiple: "複数",
      Spacing: "間隔",
      "Define new Multilevel list": "新しいマルチレベルリストを定義する",
      "List level": "リストレベル",
      "Choose level to modify": "変更するレベルを選択してください",
      Level: "レベル",
      "Number format": "数値形式",
      "Number style for this level": "このレベルの番号スタイル",
      "Enter formatting for number": "番号の書式を入力してください",
      "Start at": "で開始",
      "Restart list after": "後の再起動リスト",
      Position: "ポジション",
      "Text indent at": "テキストインデント",
      "Aligned at": "に整列",
      "Follow number with": "番号をフォロー",
      "Tab character": "タブ文字",
      Space: "スペース",
      Arabic: "アラビア語",
      UpRoman: "アップローマ",
      LowRoman: "ローマン",
      UpLetter: "アップレター",
      LowLetter: "ローレター",
      Number: "数",
      "Leading zero": "先行ゼロ",
      Bullet: "弾丸",
      Ordinal: "序数",
      "Ordinal Text": "序文",
      "For East": "東方",
      "No Restart": "再起動なし",
      Font: "フォント",
      "Font style": "フォントスタイル",
      "Underline style": "下線スタイル",
      "Font color": "フォントの色",
      Effects: "効果",
      Strikethrough: "取り消し線",
      Superscript: "上付き",
      Subscript: "添字",
      "Double strikethrough": "二重取り消し線",
      Regular: "レギュラー",
      Bold: "大胆な",
      Italic: "イタリック",
      Cut: "切る",
      Copy: "コピー",
      Paste: "ペースト",
      Hyperlink: "ハイパーリンク",
      "Open Hyperlink": "ハイパーリンクを開く",
      "Copy Hyperlink": "ハイパーリンクをコピー",
      "Remove Hyperlink": "ハイパーリンクを削除",
      Paragraph: "段落",
      "Linked Style": "リンク済み（段落とキャラクター）",
      Character: "キャラクター",
      "Merge Cells": "セルを結合します",
      "Insert Above": "上に挿入",
      "Insert Below": "下に挿入",
      "Insert Left": "左に挿入",
      "Insert Right": "右に挿入",
      Delete: "削除",
      "Delete Table": "テーブルを削除",
      "Delete Row": "行を削除",
      "Delete Column": "列を削除",
      "File Name": "ファイル名",
      "Format Type": "フォーマットタイプ",
      Save: "セーブ",
      Navigation: "ナビゲーション",
      Results: "結果",
      Replace: "交換",
      "Replace All": "すべて置換",
      "We replaced all": "すべて交換しました",
      Find: "見つける",
      "No matches": "一致なし",
      "All Done": "全部できた",
      Result: "結果",
      of: "の",
      instances: "インスタンス",
      with: "と",
      "Click to follow link": "クリックしてリンクをたどる",
      "Continue Numbering": "番号付けを続ける",
      "Bookmark name": "ブックマーク名",
      Close: "閉じる",
      "Restart At": "再起動",
      Properties: "プロパティ",
      Name: "名前",
      "Style type": "スタイルタイプ",
      "Style based on": "に基づくスタイル",
      "Style for following paragraph": "次の段落のスタイル",
      Formatting: "書式設定",
      "Numbering and Bullets": "番号付けと箇条書き",
      Numbering: "番号付け",
      "Update Field": "更新フィールド",
      "Edit Field": "フィールドを編集",
      Bookmark: "しおり",
      "Page Setup": "ページ設定",
      "No bookmarks found": "ブックマークが見つかりません",
      "Number format tooltip information":
        "単一レベルの数値形式：</br> [PREFIX]％[LEVELNUMBER] [SUFFIX] </br>たとえば、「Chapter％1。」 </br>第1章アイテム</br>第2章アイテム</br>…</br>第N章アイテム</br> </br>マルチレベル番号形式：</br> [ PREFIX]％[LEVELNUMBER] [SUFFIX] + [PREFIX]％[LEVELNUMBER] [SUFFIX] </br>たとえば、「％1.％2」 1.1のような番号が表示されます。アイテム</br> 1.2。アイテム</br>…</br> 1.N.項目",
      Format: "フォーマット",
      "Create New Style": "新しいスタイルを作成",
      "Modify Style": "スタイルを変更",
      New: "新着",
      Bullets: "箇条書き",
      "Use bookmarks": "ブックマークを使用する",
      "Table of Contents": "目次",
      AutoFit: "自動調整",
      "AutoFit to Contents": "コンテンツへの自動適合",
      "AutoFit to Window": "ウィンドウに自動調整",
      "Fixed Column Width": "固定列幅",
      Reset: "リセットする",
      "Match case": "マッチケース",
      "Whole words": "全体の言葉",
      Add: "追加",
      "Go To": "に行く",
      "Search for": "検索する",
      "Replace with": "と置換する",
      "TOC 1": "目次1",
      "TOC 2": "目次2",
      "TOC 3": "目次3",
      "TOC 4": "目次4",
      "TOC 5": "目次5",
      "TOC 6": "目次6",
      "TOC 7": "目次7",
      "TOC 8": "目次8",
      "TOC 9": "目次9",
      "Right-to-left": "右から左に",
      "Left-to-right": "左から右へ",
      Direction: "方向",
      "Table direction": "テーブルの方向",
      "Indent from right": "右からインデント",
      "Contextual Spacing":
        "同じスタイルの段落間にスペースを追加しないでください",
      "Password Mismatch": "パスワードが一致しません",
      "Restrict Editing": "編集を制限する",
      "Formatting restrictions": "フォーマットの制限",
      "Allow formatting": "フォーマットを許可する",
      "Editing restrictions": "編集制限",
      "Read only": "読み取り専用",
      "Exceptions Optional": "例外（オプション）",
      "Select Part Of Document And User":
        "文書の一部を選択し、自由に編集できるユーザーを選択します。",
      Everyone: "全員",
      "More users": "より多くのユーザー",
      "Add Users": "ユーザーを追加",
      "Enforcing Protection": "はい、保護の実施を開始します",
      "Start Enforcing Protection": "保護の実施を開始",
      "Enter User": "ユーザーを入力",
      Users: "ユーザー",
      "Enter new password": "新しいパスワードを入力してください",
      "Reenter new password to confirm":
        "確認のために新しいパスワードを再入力してください",
      "Your permissions": "あなたの許可",
      "Protected Document":
        "このドキュメントは意図しない編集から保護されています。この地域で編集できます。",
      FormFieldsOnly: "この地域のフォームにのみ記入できます。",
      CommentsOnly: "この領域にのみコメントを挿入できます。",
      ReadOnlyProtection: "この地域で編集できます。",
      "Stop Protection": "保護を停止",
      Password: "パスワード",
      "Spelling Editor": "スペルエディター",
      Spelling: "つづり",
      "Spell Check": "スペルチェック",
      "Underline errors": "エラーに下線を引く",
      Ignore: "無視する",
      "Ignore All": "すべて無視",
      "Add to Dictionary": "辞書に追加",
      Change: "変化する",
      "Change All": "すべて変更",
      Suggestions: "提案",
      "The password is incorrect": "パスワードが間違っています",
      "Error in establishing connection with web server":
        "Webサーバーとの接続を確立する際のエラー",
      "Highlight the regions I can edit": "編集可能な地域をハイライトします",
      "Show All Regions I Can Edit": "編集可能なすべての地域を表示",
      "Find Next Region I Can Edit": "編集可能な次の地域を検索",
      "Keep source formatting": "ソースのフォーマットを保持",
      "Match destination formatting": "一致先のフォーマット",
      "Text only": "テキストのみ",
      Comments: "コメント",
      "Type your comment": "コメントを入力してください",
      Post: "役職",
      Reply: "応答",
      "New Comment": "新しいコメント",
      Edit: "編集",
      Resolve: "解決する",
      Reopen: "再開する",
      "No comments in this document":
        "このドキュメントにはコメントがありません",
      more: "もっと",
      "Type your comment here": "ここにコメントを入力してください",
      "Next Comment": "次のコメント",
      "Previous Comment": "前のコメント",
      "Un-posted comments": "未投稿のコメント",
      "Discard Comment":
        "投稿されていないコメントを追加しました。続行すると、そのコメントは破棄されます。",
      Discard: "破棄",
      "No Headings": "見出しが見つかりません！",
      "Add Headings":
        "このドキュメントには見出しがありません。見出しを追加してもう一度お試しください。",
      "More Options": "より多くのオプション",
      "Click to see this comment": "クリックしてこのコメントを表示",
      "Drop Down Form Field": "ドロップダウンフォームフィールド",
      "Drop-down items": "ドロップダウンアイテム",
      "Items in drop-down list": "ドロップダウンリストの項目",
      ADD: "追加",
      REMOVE: "削除する",
      "Field settings": "フィールド設定",
      Tooltip: "ツールチップ",
      "Drop-down enabled": "ドロップダウンが有効",
      "Check Box Form Field": "チェックボックスフォームフィールド",
      "Check box size": "チェックボックスサイズ",
      Auto: "自動",
      "Default value": "デフォルト値",
      "Not checked": "未検査",
      Checked: "チェック済み",
      "Check box enabled": "チェックボックスを有効にしました",
      "Text Form Field": "テキストフォームフィールド",
      Type: "タイプ",
      "Default text": "デフォルトのテキスト",
      "Maximum length": "最大長",
      "Text format": "テキスト形式",
      "Fill-in enabled": "フィルインが有効",
      "Default number": "デフォルト番号",
      "Default date": "デフォルトの日付",
      "Date format": "日付形式",
      "Merge Track":
        "このアクションは変更としてマークされません。続けたいですか？",
      UnTrack: "追跡できません",
      Accept: "受け入れる",
      Reject: "拒否する",
      "Previous Changes": "以前の変更",
      "Next Changes": "次の変更",
      Inserted: "挿入",
      Deleted: "削除しました",
      "Move From": "そして",
      "Move To": "怒り",
      Changes: "変化",
      "Accept all": "すべてを受け入れる",
      "Reject all": "すべて拒否",
      "No changes": "変更なし",
      "Accept Changes": "変更を受け入れる",
      "Reject Changes": "変更を拒否",
      User: "ユーザー",
      View: "見る",
      Insertion: "挿入",
      Deletion: "削除",
      "All caps": "すべて大文字",
      "This region is locked by": "この地域はによってロックされています",
      Lock: "ロック",
      Unlock: "ロックを解除する",
      "Already locked":
        "選択された領域または領域の一部がすでに別のユーザーによってロックされています",
      "1, 2, 3, ...": "1、2、3、..。",
      "a, b, c, ...": "a、b、c、..。",
      "A, B, C, ...": "A、B、C、...",
      "I, II, III, ...": "I、II、III、...",
      "i, ii, iii, ...": "i、ii、iii、..。",
      "Text Form": "テキストフォーム",
      "Check Box": "チェックボックス",
      DropDown: "落ちる",
      "Form Fields": "フォームフィールド",
      "Fillin enabled": "入力が有効",
      "Multiple Comment": "コメントを投稿してください",
      InsertFootnote: "挿入脚注",
      InsertEndnote: "文末脚注の挿入",
      Footnote: "脚注",
      Endnote: "巻末注",
      "Notes Options": "オプションを確認してください",
      "Click to View/Edit Footnote":
        "脚注を表示/編集するにはクリックしてください",
      "Click to View/Edit Endnote": "クリックして文末脚注を表示/編集",
      InsertAsRows: "新しい行として挿入",
      InsertAsColumns: "新しい列として挿入",
      OverwriteCells: "セルを上書きする",
      NestTable: "ネストテーブル",
      "No suggestions": "提案はありません",
      "More Suggestion": "より多くの提案",
      "Ignore Once": "一度無視する",
      "Keep With Next": "次を続ける",
      "Keep Lines Together": "行を一緒に保つ",
      WidowControl: "未亡人/孤児のコントロール",
      "Indents and Spacing": "インデントと間隔",
      "Line and Page Breaks": "行とページの区切り",
      Pagination: "ページ付け",
      Single: "独身",
      DashSmallGap: "ダッシュ小ギャップ",
      DashDot: "ダッシュドット",
      Double: "ダブル",
      ThinThickSmallGap: "薄厚小ギャップ",
      ThickThinSmallGap: "厚い薄い小さなギャップ",
      ThickThinMediumGap: "厚い薄い中ギャップ",
      ThickThinLargeGap: "厚い薄い大ギャップ",
      SingleWavy: "シングルウェーブ",
      DoubleWavy: "ダブルウェーブ",
      Inset: "挿入図",
      DashLargeGap: "ダッシュ大ギャップ",
      Dot: "ドット",
      DashDotDot: "ダッシュドットドット",
      Triple: "トリプル",
      ThinThickThinSmallGap: "薄厚薄小ギャップ",
      ThinThickThinMediumGap: "薄厚薄中ギャップ",
      ThinThickThinLargeGap: "薄厚薄大ギャップ",
      DashDotStroked: "ダッシュドットストローク",
      Engrave3D: "彫刻3D",
      Thick: "厚い",
      Outset: "最初",
      Emboss3D: "エンボス3D",
      ThinThickLargeGap: "薄厚大ギャップ",
      ThinThickMediumGap: "薄厚中ギャップ",
      "Number of rows must be between": "行数は次の範囲内である必要があります",
      "Number of columns must be between":
        "列数は次の範囲内である必要があります",
      and: "と",
      Unlimited: "無制限",
      "Regular text": "通常のテキスト",
      Date: "日にち",
      Uppercase: "大文字",
      Lowercase: "小文字",
      FirstCapital: "ファーストキャピタル",
      TitleCase: "タイトルケース",
      "Filling in forms": "フォームへの記入",
      px: "ピクセル",
      "Tracked changes": "追跡された変更",
      TrackChangesOnly:
        "このリージョンで編集できますが、すべての変更が追跡されます。",
      RemovedIgnore: "無視された例外を削除しますか？",
      RemovedIgnoreExceptions:
        "ドキュメント保護でこの変更を行うと、Wordはこのドキュメントのすべての例外を無視します。",
      Information: "情報",
      Yes: "はい",
      No: "番号",
      "Page Break": "改ページ",
      "Column Break": "段区切り",
      "Section Break Next Page": "セクション区切り (次のページ)",
      "Section Break Continuous": "セクション区切り (連続)",
      "Unsupported format":
        "選択したファイル形式はサポートされていません。有効な形式を選択してください。",
      One: "一",
      Two: "二",
      Three: "三つ",
      Presets: "プリセット",
      Columns: "コラム",
      "Split your text into two or more columns":
        "テキストを 2 つ以上の列に分割する",
      "Line between column": "列間の線",
      "Width and Spacing": "幅と間隔",
      "Equal column width": "列幅が等しい",
      Column: "桁",
      "Paste Content Dialog":
        "ブラウザのセキュリティ ポリシーにより、システム クリップボードからの貼り付けは制限されています。",
      "Paste Content CheckBox": "二度と現れないでください",
      "The top/bottom margins are too large for the page height in some sections.":
        "一部のセクションでは、上下の余白がページの高さに対して大きすぎます。",
      "Column width cannot be less than 36 pt.":
        "列幅は 36 ポイント未満にすることはできません。",
      "Left and right margins.":
        "左右の余白、段落の間隔、または段落のインデントに対して選択した設定が、同じセクションのページ幅に対して大きすぎます。",
      "The address of this site is 'not valid. Check the address and try again.":
        "このサイトのアドレスは無効です。アドレスを確認して再試行してください。",
      "Alt Text": "代替テキスト",
      Title: "タイトル",
      Description: "説明",
      "Left Indent": "コミュニケーション分野",
      "Right Indent": "正しいコース",
      "Hanging Indent": "誰もが果たすべき役割を持っています",
      "First Line Indent": "1つ目はラインの曲がりです。",
      "Left Margin": "左隅",
      "Right Margin": "良い良い",
      "Top Margin": "テスタ",
      "Bottom Margin": "オンにする",
      "Left Tab": "左の耳",
      "Right Tab": "右耳",
      "Center Tab": "中央インジケーター",
      "Decimal Tab": "動物の屠殺",
      "Bar Tab": "コミルヴィ",
      "Move Table Column": "テーブルの列を移動する",
      external: "コンテンツコントロールを削除します",
      "Content Control Properties": "コンテンツ制御プロパティ",
      "Remove content control when contents are edited":
        "コンテンツが編集されたら、コンテンツコントロールを削除します",
      "Content control cannot be deleted":
        "コンテンツコントロールを削除することはできません",
      "Contents cannot be edited": "内容は編集できません",
      "Plain Text properties": "プレーンテキストプロパティ",
      "Allow carriage returns": "キャリッジの返品を許可します",
      "Drop_Down List properties": "Drop_Downリストプロパティ",
      "Display Text": "テキストを表示します",
      Locking: "ロック",
      Tag: "鬼ごっこ",
      Value: "価値",
      PictureContentControl: "PictureContentControl",
      "Upload from computer": "コンピュータからアップロード",
      Picture: "写真",
      "Choose an item": "アイテムを選択してください",
      "Paste CheckBox Content Dialog": "二度と表示しないでください",
      "The address of this site is not valid. Check the address and try again.":
        "このサイトのアドレスは無効です。",
      "Left and right margins":
        "左右の余白、段落の間隔、または段落のインデントに対して選択した設定が、同じセクションのページ幅に対して大きすぎます。",
      "Number of rows must be between 1 and 32767.":
        "行数は 1 ～ 32767 でなければなりません。",
      "Number of columns must be between 1 and 63.":
        "列数は 1 ～ 63 でなければなりません。",
      "You may format text only with certain styles":
        "特定のスタイルでのみテキストを書式設定できます。",
      "Ignore all": "すべて無視",
    },
    documenteditorcontainer: {
      New: "新着",
      Open: "開いた",
      Undo: "元に戻す",
      Redo: "やり直し",
      Image: "画像",
      Table: "テーブル",
      Link: "リンク",
      Bookmark: "しおり",
      "Table of Contents": "目次",
      "HEADING - - - - 1": "見出し----1",
      "HEADING - - - - 2": "見出し----2",
      "HEADING - - - - 3": "見出し----3",
      Header: "ヘッダ",
      Footer: "フッター",
      "Page Setup": "ページ設定",
      "Page Number": "ページ番号",
      Break: "ブレーク",
      Find: "見つける",
      "Local Clipboard": "ローカルクリップボード",
      "Restrict Editing": "編集を制限する",
      "Content Control": "コンテンツコントロール",
      "Rich Text Content Control": "豊富なテキストコンテンツコントロール",
      "Plain Text Content Control": "プレーンテキストコンテンツコントロール",
      "Picture Content Control": "画像コンテンツコントロール",
      "Combo Box Content Control": "コンボボックスコンテンツコントロール",
      "Drop-Down List Content Control":
        "ドロップダウンリストコンテンツコントロール",
      "Date Picker Content Control": "日付ピッカーコンテンツコントロール",
      "Check Box Content Control": "チェックボックスコンテンツコントロール",
      "Upload from computer": "コンピュータからアップロード",
      "By URL": "URLで",
      "Page Break": "改ページ",
      "Section Break": "セクション区切り",
      "Header And Footer": "ヘッダーとフッター",
      Options: "オプション",
      Levels: "レベル",
      "Different First Page": "別の最初のページ",
      "Different header and footer for odd and even pages":
        "奇数ページと偶数ページで異なるヘッダーとフッター。",
      "Different Odd And Even Pages": "異なる奇数ページと偶数ページ",
      "Different header and footer for first page":
        "最初のページのヘッダーとフッターが異なります。",
      Position: "ポジション",
      "Header from Top": "上からのヘッダー",
      "Footer from Bottom": "下からのフッター",
      "Distance from top of the page to top of the header":
        "ページの上部からヘッダーの上部までの距離。",
      "Distance from bottom of the page to bottom of the footer":
        "ページの下部からフッターの下部までの距離。",
      "Aspect ratio": "アスペクト比",
      W: "W",
      H: "H",
      Width: "幅",
      Height: "高さ",
      Text: "テキスト",
      Paragraph: "段落",
      Fill: "塗りつぶし",
      "Fill color": "塗りつぶしの色",
      "Border Style": "ボーダースタイル",
      "Outside borders": "外枠",
      "All borders": "すべての国境",
      "Inside borders": "内枠",
      "Left border": "左ボーダー",
      "Inside vertical border": "内側の垂直境界線",
      "Right border": "右ボーダー",
      "Top border": "上罫線",
      "Inside horizontal border": "内側の水平方向の境界線",
      "Bottom border": "下枠",
      "Border color": "ボーダの色",
      "Border width": "ボーダー幅",
      Cell: "細胞",
      "Merge cells": "セルを結合します",
      "Insert Or Delete": "挿入/削除",
      "Insert columns to the left": "列を左に挿入",
      "Insert columns to the right": "列を右に挿入",
      "Insert rows above": "上に行を挿入",
      "Insert rows below": "下に行を挿入",
      "Delete rows": "行を削除する",
      "Delete columns": "列を削除する",
      "Cell Margin": "セルマージン",
      Top: "上",
      Bottom: "底",
      Left: "左",
      Right: "正しい",
      "Align Text": "テキストを揃える",
      "Align top": "上揃え",
      "Align bottom": "下揃え",
      "Align center": "中央揃え",
      "Number of heading or outline levels to be shown in table of contents":
        "目次に表示される見出しまたはアウトラインレベルの数。",
      "Show page numbers": "ページ番号を表示する",
      "Show page numbers in table of contents":
        "目次にページ番号を表示します。",
      "Right align page numbers": "ページ番号を右揃え",
      "Right align page numbers in table of contents":
        "目次のページ番号を右揃えにします。",
      "Use hyperlinks": "ハイパーリンクを使用する",
      "Use hyperlinks instead of page numbers":
        "ページ番号の代わりにハイパーリンクを使用します。",
      Font: "フォント",
      "Font Size": "フォントサイズ",
      "Font color": "フォントの色",
      "Text highlight color": "テキストのハイライト色",
      "Clear all formatting": "すべてのフォーマットをクリア",
      "Bold Tooltip": "太字（Ctrl + B）",
      "Italic Tooltip": "斜体（Ctrl + I）",
      "Underline Tooltip": "下線（Ctrl + U）",
      Strikethrough: "取り消し線",
      "Superscript Tooltip": "上付き文字（Ctrl + Shift ++）",
      "Subscript Tooltip": "下付き文字（Ctrl + =）",
      "Align left Tooltip": "左揃え（Ctrl + L）",
      "Center Tooltip": "中央（Ctrl + E）",
      "Align right Tooltip": "右揃え（Ctrl + R）",
      "Justify Tooltip": "両端揃え（Ctrl + J）",
      "Decrease indent": "インデントを減らす",
      "Increase indent": "インデントを増やします",
      "Line spacing": "行間隔",
      Bullets: "箇条書き",
      Numbering: "番号付け",
      Styles: "スタイル",
      "Manage Styles": "スタイルを管理する",
      Page: "ページ",
      of: "の",
      "Fit one page": "1ページに収める",
      "Spell Check": "スペルチェック",
      Spelling: "何でもありません",
      "Underline errors": "エラーに下線を引く",
      "Fit page width": "ページ幅に合わせる",
      Update: "更新",
      Cancel: "キャンセル",
      Insert: "インサート",
      "No Border": "境界が無い",
      "Create a new document": "新しいドキュメントを作成します。",
      "Open a document": "文書を開きます。",
      "Undo Tooltip": "最後の操作を元に戻します（Ctrl + Z）。",
      "Redo Tooltip": "最後の操作をやり直します（Ctrl + Y）。",
      "Insert inline picture from a file":
        "ファイルからインライン画像を挿入します。",
      "Insert a table into the document": "ドキュメントに表を挿入します",
      "Create Hyperlink":
        "ドキュメントにリンクを作成して、Webページとファイルにすばやくアクセスします（Ctrl + K）。",
      "Insert a bookmark in a specific place in this document":
        "このドキュメントの特定の場所にブックマークを挿入します。",
      "Provide an overview of your document by adding a table of contents":
        "目次を追加して、ドキュメントの概要を提供します。",
      "Add or edit the header": "ヘッダーを追加または編集します。",
      "Add or edit the footer": "フッターを追加または編集します。",
      "Open the page setup dialog": "ページ設定ダイアログを開きます。",
      "Add page numbers": "ページ番号を追加します。",
      "Find Text": "ドキュメント内のテキストを検索します（Ctrl + F）。",
      "Toggle between the internal clipboard and system clipboard":
        "内部クリップボードとシステムクリップボードを切り替えます。</br>ブラウザのセキュリティポリシーにより、スクリプトを介したシステムクリップボードへのアクセスは拒否されます。代わりに、</br> 1.内部クリップボードを有効にして、コンポーネント内で切り取り、コピー、貼り付けを行うことができます。</br> 2.キーボードショートカット（Ctrl + X、Ctrl + C、Ctrl + V）を使用して切り取ります。 、システムクリップボードを使用してコピーして貼り付けます。",
      "Current Page Number":
        "ドキュメント内の現在のページ番号。クリックまたはタップして特定のページに移動します。",
      "Read only": "読み取り専用",
      Protections: "保護",
      "Error in establishing connection with web server":
        "Webサーバーとの接続を確立する際のエラー",
      Single: "シングル",
      Double: "ダブル",
      "New comment": "新しいコメント",
      Comments: "コメント",
      "Print layout": "印刷レイアウト",
      "Web layout": "Webレイアウト",
      "Text Form": "テキストフォーム",
      "Check Box": "チェックボックス",
      DropDown: "落ちる",
      "Update Fields": "フィールドを更新",
      "Update cross reference fields": "相互参照フィールドを更新する",
      "Hide properties pane": "プロパティペインを非表示",
      "Show properties pane": "プロパティペインを表示",
      "Form Fields": "フォームフィールド",
      "Track Changes": "ドキュメントに加えられた変更を追跡します",
      TrackChanges: "変更の追跡",
      AllCaps: "すべて大文字",
      "Change case Tooltip": "ケースを変更する",
      "Insert Footnote": "脚注を挿入",
      "Insert Endnote": "Endnoteを挿入",
      "Footnote Tooltip": "脚注を挿入します（Alt + Ctrl + F）。",
      "Endnote Tooltip": "Endnoteを挿入します（Alt + Ctrl + D）。",
      UPPERCASE: "大文字",
      "No color": "色なし",
      "Top margin": "トップマージン",
      "Bottom margin": "下マージン",
      "Left margin": "左マージン",
      "Right margin": "右マージン",
      Normal: "普通",
      Heading: "見出し",
      "Heading 1": "見出し1",
      "Heading 2": "見出し2",
      "Heading 3": "見出し3",
      "Heading 4": "見出し4",
      "Heading 5": "見出し5",
      "Heading 6": "見出し6",
      ZoomLevelTooltip:
        "ズームレベル。クリックまたはタップして、ズームオプションを開きます。",
      None: "なし",
      Borders: "ボーダーズ",
      "ShowHiddenMarks Tooltip":
        "スペース、タブ、段落記号、改行などの隠し文字を表示します。(Ctrl + *)",
      Columns: "コラム",
      "Column Break": "段区切り",
      "Link to Previous": "前のリンク",
      "Link to PreviousTooltip":
        "このセクションを前のセクションのヘッダーまたはフッターにリンクします",
      "Alternate Text": "代替テキスト",
      "The address of this site is not valid. Check the address and try again.":
        "このサイトのアドレスは無効です。",
      OK: "わかりました",
      Information: "情報",
      "Page Breaks": "ページの最後に",
      "Section Breaks": "この部門は崩壊しました",
      Column: "これを共有",
      "Next Page": "次のページ",
      Continuous: "仕事",
    },
    carousel: {
      nextSlide: "次のスライド",
      of: "の",
      pauseSlideTransition: "スライドトランジションを一時停止します",
      playSlideTransition: "スライドトランジションを再生する",
      previousSlide: "前のスライド",
      slide: "滑り台",
      slideShow: "スライドショー",
    },
    message: {
      close: "近い",
    },
    "image-editor": {
      "0": "0%",
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "5": "5",
      "20": "20%",
      "40": "40%",
      "60": "60%",
      "80": "80%",
      "100": "100%",
      Crop: "作物",
      CropAndTransform: "切り抜きと変形",
      ZoomIn: "ズームイン",
      ZoomOut: "ズームアウトする",
      Undo: "元に戻す",
      Redo: "やり直し",
      Transform: "変身",
      Annotation: "注釈",
      Finetune: "微調整",
      Brightness: "輝度",
      Contrast: "対比",
      Hue: "色相",
      Saturation: "飽和",
      Opacity: "不透明度",
      Blur: "ぼかし",
      Sharpen: "研ぐ",
      Exposure: "暴露",
      Filter: "フィルター",
      Default: "デフォルト",
      Chrome: "クロム",
      Cold: "寒い",
      Warm: "暖かい",
      Grayscale: "グレースケール",
      BlackAndWhite: "黒と白",
      Sepia: "セピア",
      Invert: "反転",
      Text: "テキストを追加",
      Pen: "ペン",
      Reset: "リセット",
      Save: "保存",
      Select: "選択する",
      RotateLeft: "左に回転",
      RotateRight: "右に回る",
      HorizontalFlip: "水平反転",
      VerticalFlip: "垂直反転",
      OK: "わかりました",
      Cancel: "キャンセル",
      DlgOK: "わかりました",
      FillColor: "塗りつぶしの色",
      StrokeColor: "ストロークの色",
      StrokeWidth: "ストローク幅",
      FontFamily: "フォントファミリー",
      FontStyle: "フォントスタイル",
      FontSize: "フォントサイズ",
      FontColor: "フォントの色",
      Pan: "パン",
      Move: "動く",
      Load: "負荷",
      Custom: "カスタム",
      Square: "四角",
      Circle: "丸",
      Ellipse: "楕円",
      Rectangle: "矩形",
      Line: "ライン",
      Arrow: "矢印",
      Path: "パス",
      Bold: "大胆な",
      Italic: "イタリック",
      BoldItalic: "ボールドイタリック",
      XSmall: "X-Small",
      Small: "小さい",
      Medium: "中くらい",
      Large: "大きい",
      XLarge: "×ラージ",
      ABC: "ABC",
      Browse: "ブラウズ",
      Duplicate: "重複",
      Remove: "取り除く",
      EditText: "テキストの編集",
      Start: "始める",
      End: "終わり",
      Bar: "バー",
      ArrowSolid: "実線の矢印",
      CircleSolid: "円形ソリッド",
      SquareSolid: "四角い立体",
      None: "なし",
      CropSelection: "クロップの選択",
      Image: "画像を追加",
      Transparency: "透明性",
      Height: "身長",
      Width: "幅",
      AspectRatio: "アスペクト比を維持",
      W: "W",
      H: "H",
      DragText: "ここに画像をドラッグ アンド ドロップするか、",
      DropText: "ここに画像をドロップするか、",
      BrowseText: "ここを参照...",
      SupportText: "サポート:",
      Frame: "フレーム",
      Mat: "マット",
      Bevel: "ベベル",
      Inset: "挿入図",
      Hook: "針",
      Color: "色",
      Size: "サイズ",
      Offset: "オフセット",
      Radius: "半径",
      Amount: "額",
      Resize: "サイズ変更",
      Border: "国境",
      Solid: "固体",
      Dashed: "破線",
      Dotted: "点在",
      GradientColor: "グラデーションカラー",
      ConfirmDialogHeader: "変更の保存を確認する",
      ConfirmDialogContent: "画像に加えた変更を保存しますか?",
      AlertDialogHeader: "サポートされていないファイル",
      AlertDialogContent: "ドロップされたファイルはサポートされていません。",
      Yes: "はい",
      No: "いいえ",
      ImageErrorDialogHeader: "画像選択エラー",
      ImageErrorDialogContent: "開きたい画像を選択するだけです。",
      Straighten: "期限を守る",
      NoOutline: "輪郭が無い",
      Clone: "比喩",
      Delete: "破壊する",
      SaveAs: "名前を付けて保存",
      ImageName: "画像名",
      Format: "フォーマット",
      Quality: "品質",
      Download: "ダウンロード",
      Close: "近い",
      ImageSize: "画像サイズ",
      QualityInfo: "画質オプションはJPEG形式でのみ使用できます",
      Good: "良い",
      Great: "素晴らしい",
      Highest: "最高",
      BringForward: "前に持っていく",
      SendBackward: "後方に送ります",
      SendToBack: "返送してください",
      BringToFront: "前に持ってくる",
      ZOrder: "zオーダー",
      Redact: "編集",
      Pixelate: "ピクセル酸塩",
      BorderRadius: "境界半径",
      TextOutlineColor: "アウトライン色",
      TextOutlineWidth: "アウトライン幅",
    },
    mention: {
      noRecordsTemplate: "レコードが見つかりません",
    },
    inplaceeditor: {
      save: "保存",
      cancel: "キャンセル",
      loadingText: "読み込み中...",
      editIcon: "クリックして編集する",
      editAreaClick: "クリックして編集する",
      editAreaDoubleClick: "ダブルクリックして編集します",
    },
    PdfViewer: {
      PdfViewer: "PDFビューア",
      Cancel: "キャンセル",
      "Download file": "ダウンロードファイル",
      Download: "ダウンロード",
      "Enter Password": "この文書はパスワードで保護されています。",
      "File Corrupted": "ファイルが壊れた",
      "File Corrupted Content": "ファイルが壊れているため開けません。",
      "Fit Page": "ページに合わせる",
      "Fit Width": "フィット幅",
      Automatic: "自動",
      "Go To First Page": "最初のページを表示",
      "Invalid Password": "パスワードが間違っています。",
      "Next Page": "次のページを表示",
      OK: "わかりました",
      Open: "ファイルを開く",
      "Page Number": "現在のページ番号",
      "Previous Page": "前のページを表示",
      "Go To Last Page": "最後のページを表示",
      Zoom: "ズーム",
      "Zoom In": "ズームイン",
      "Zoom Out": "ズームアウトする",
      "Page Thumbnails": "ページのサムネイル",
      Bookmarks: "ブックマーク",
      Print: "印刷ファイル",
      "Organize Pages": "ページを整理する",
      "Insert Right": "右挿入します",
      "Insert Left": "左に挿入します",
      Total: "合計",
      Pages: "ページ",
      "Rotate Right": "右に回る",
      "Rotate Left": "左に回転",
      "Delete Page": "ページを削除します",
      "Delete Pages": "ページを削除します",
      "Copy Page": "ページをコピーします",
      "Copy Pages": "ページをコピーします",
      "Import Document": "インポートドキュメント",
      Save: "保存",
      "Save As": "名前を付けて保存",
      "Select All": "すべて選択",
      "Password Protected": "パスワードが必要",
      Copy: "コピー",
      "Text Selection": "テキスト選択ツール",
      Panning: "パンモード",
      "Text Search": "テキストの検索",
      "Find in document": "文書内で検索",
      "Match case": "マッチケース",
      "Match any word": "任意の単語に一致します",
      Apply: "適用する",
      GoToPage: "ページに移動",
      "No Matches":
        "PDF Viewer はドキュメントの検索を終了しました。一致するものが見つかりませんでした。",
      "No More Matches":
        "PDF Viewer はドキュメントの検索を終了しました。これ以上一致するものは見つかりませんでした。",
      "Exact Matches": "正確な一致",
      "Total Matches": "合計マッチ",
      Undo: "元に戻す",
      Redo: "やり直し",
      Annotation: "注釈の追加または編集",
      FormDesigner: "フォームフィールドを追加および編集します",
      Highlight: "テキストを強調表示する",
      Underline: "テキストに下線を引く",
      Strikethrough: "取り消し線のテキスト",
      Delete: "注釈の削除",
      Opacity: "不透明度",
      "Color edit": "色を変える",
      "Opacity edit": "不透明度の変更",
      "Highlight context": "ハイライト",
      "Underline context": "下線",
      "Strikethrough context": "取り消し線",
      "Server error": "Web サービスがリッスンしていません。 ",
      "Client error":
        "クライアント側のエラーが見つかりました。 AjaxRequestSettingsプロパティとServerActionSettingsプロパティのWebアクションメソッドで提供されるカスタムヘッダーを確認してください。",
      "Open text": "開ける",
      "First text": "一ページ目",
      "Previous text": "前のページ",
      "Next text": "次のページ",
      "Last text": "最後のページ",
      "Zoom in text": "ズームイン",
      "Zoom out text": "ズームアウトする",
      "Selection text": "選択",
      "Pan text": "パン",
      "Print text": "印刷する",
      "Search text": "検索",
      "Annotation Edit text": "注釈の編集",
      "FormDesigner Edit text": "フォームフィールドを追加および編集します",
      "Line Thickness": "線の太さ",
      "Line Properties": "線のプロパティ",
      "Start Arrow": "スタートアロー",
      "End Arrow": "エンドアロー",
      "Line Style": "線のスタイル",
      "Fill Color": "塗りつぶしの色",
      "Line Color": "線の色",
      None: "なし",
      "Open Arrow": "開ける",
      "Closed Arrow": "閉まっている",
      "Round Arrow": "ラウンド",
      "Square Arrow": "四角",
      "Diamond Arrow": "ダイヤモンド",
      Butt: "お尻",
      Cut: "カット",
      Paste: "ペースト",
      "Delete Context": "消去",
      Properties: "プロパティ",
      "Add Stamp": "スタンプを追加する",
      "Add Shapes": "図形の追加",
      "Stroke edit": "ストロークの色の変更",
      "Change thickness": "境界線の太さを変更する",
      "Add line": "行を追加",
      "Add arrow": "矢印を追加",
      "Add rectangle": "長方形の追加",
      "Add circle": "サークルを追加",
      "Add polygon": "ポリゴンの追加",
      "Add Comments": "コメントの追加",
      Comments: "コメント",
      SubmitForm: "フォームを送信",
      "No Comments Yet": "コメントはまだありません",
      Accepted: "承認されました",
      Completed: "完了しました",
      Cancelled: "キャンセル",
      Rejected: "拒否されました",
      "Leader Length": "リーダーの長さ",
      "Scale Ratio": "スケール比",
      Calibrate: "校正する",
      "Calibrate Distance": "距離の校正",
      "Calibrate Perimeter": "周囲を校正する",
      "Calibrate Area": "エリアの校正",
      "Calibrate Radius": "半径の校正",
      "Calibrate Volume": "音量の調整",
      Depth: "深さ",
      Closed: "閉まっている",
      Round: "ラウンド",
      Square: "四角",
      Diamond: "ダイヤモンド",
      Edit: "編集",
      Comment: "コメント",
      "Comment Panel": "コメントパネル",
      "Set Status": "ステータスの設定",
      Post: "役職",
      Page: "ページ",
      "Add a comment": "コメントを追加する",
      "Add a reply": "返信を追加",
      "Import Annotations": "JSONファイルからアノテーションをインポートします",
      "Export Annotations": "JSONファイルに注釈をエクスポートします",
      "Export XFDF": "XFDFファイルに注釈をエクスポートします",
      "Import XFDF": "XFDFファイルから注釈をインポートします",
      Add: "追加",
      Clear: "クリア",
      Bold: "大胆な",
      Italic: "イタリック",
      Strikethroughs: "取り消し線",
      Underlines: "下線",
      Superscript: "上付き文字",
      Subscript: "添字",
      "Align left": "左揃え",
      "Align right": "右揃え",
      Center: "中心",
      Justify: "正当化する",
      "Font color": "フォントの色",
      "Text Align": "テキストアライメント",
      "Text Properties": "フォントスタイル",
      SignatureFieldDialogHeaderText: "署名を追加します",
      HandwrittenSignatureDialogHeaderText: "署名を追加します",
      InitialFieldDialogHeaderText: "初期を追加します",
      HandwrittenInitialDialogHeaderText: "初期を追加します",
      "Draw Ink": "インクを描きます",
      Create: "作成する",
      "Font family": "フォントファミリー",
      "Font size": "フォントサイズ",
      "Free Text": "フリーテキスト",
      "Import Failed":
        "無効なJSONファイルタイプまたはファイル名。有効なJSONファイルを選択してください",
      "Import PDF Failed":
        "無効なPDFファイルタイプまたはPDFファイルが見つかりません。有効なPDFファイルを選択してください",
      "File not found":
        "インポートされたJSONファイルは目的の場所にはありません",
      "Export Failed":
        "アノテーションアクションのエクスポートは失敗しました。注釈が適切に追加されていることを確認してください",
      of: "の",
      Dynamic: "動的",
      "Standard Business": "標準的なビジネス",
      "Sign Here": "ここにサインしてください",
      "Custom Stamp": "カスタムスタンプ",
      "Enter Signature as Name": "あなたの名前を入力してください",
      "Draw-hand Signature": "描く",
      "Type Signature": "タイプ",
      "Upload Signature": "アップロード",
      "Browse Signature Image": "ブラウズ",
      "Save Signature": "署名を保存します",
      "Save Initial": "初期を保存します",
      Textbox: "テキストボックス",
      Password: "パスワード",
      "Check Box": "チェックボックス",
      "Radio Button": "ラジオボタン",
      Dropdown: "落ちる",
      "List Box": "リストボックス",
      Signature: "サイン",
      "Delete FormField": "フォームフィールドを削除します",
      "Textbox Properties": "テキストボックスのプロパティ",
      Name: "名前",
      Tooltip: "ツールチップ",
      Value: "価値",
      "Form Field Visibility": "フィールドの可視性を形成します",
      "Read Only": "読み取り専用",
      Required: "必須",
      Checked: "チェック済み",
      "Show Printing": "印刷を表示します",
      Formatting: "フォーマット",
      Fill: "埋める",
      Border: "国境",
      "Border Color": "ボーダの色",
      Thickness: "厚さ",
      "Max Length": "最大長さ",
      "List Item": "項目名",
      "Export Value": "アイテム値",
      "Dropdown Item List": "ドロップダウンアイテムリスト",
      "List Box Item List": "ボックスアイテムリストをリストします",
      General: "一般的な",
      Appearance: "外観",
      Options: "オプション",
      "Delete Item": "消去",
      Up: "上",
      Down: "下",
      Multiline: "マルチライン",
      Revised: "改訂",
      Reviewed: "審査",
      Received: "受け取った",
      Confidential: "機密",
      Approved: "承認された",
      "Not Approved": "未承認",
      Witness: "目撃者",
      "Initial Here": "ここで初めて",
      Draft: "下書き",
      Final: "最後の",
      "For Public Release": "公開のため",
      "Not For Public Release": "公開のためではありません",
      "For Comment": "コメントのために",
      Void: "空所",
      "Preliminary Results": "予備的な結果",
      "Information Only": "情報のみ",
      in: "で",
      m: "メートル",
      ft_in: "ft_in",
      ft: "フィート",
      p: "p",
      cm: "cm",
      mm: "んん",
      pt: "ポイント",
      cu: "キュ",
      sq: "平方",
      Initial: "イニシャル",
      "No Search Matches": "一致するものが見つかりませんでした",
      "No More Search Matches": "これ以上一致するものは見つかりませんでした",
      "No matches": "閲覧者はドキュメントの検索を終了しました。",
      "No Text Found": "テキストが見つかりません",
    },
    stepper: {
      optional: "オプション",
    },
  },
};
